/**
 * AlphaX ECU Staff Design & Revision Tracker
 * Interactive Frontend Controller & State Manager
 */

// 1. Configure deployed Google Apps Script Web App URL:

  // Rich Console Logger for Development & Diagnostics
  const Logger = {
    log: (title, ...args) => console.log(`%c[AlphaX Tracker] %c${title}`, 'color: #38bdf8; font-weight: bold;', 'color: #f8fafc;', ...args),
    auth: (title, ...args) => console.log(`%c[AlphaX Auth] %c${title}`, 'color: #34d399; font-weight: bold;', 'color: #cbd5e1;', ...args),
    api: (title, ...args) => console.log(`%c[AlphaX API] %c${title}`, 'color: #fbbf24; font-weight: bold;', 'color: #e2e8f0;', ...args),
    warn: (title, ...args) => console.warn(`%c[AlphaX Warn] %c${title}`, 'color: #f87171; font-weight: bold;', 'color: #fca5a5;', ...args)
  };

  const APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxe2TdIbnTiq1WHfOYeiioO1kK-3oYUAWWANquQE-xLqNe4pyl_wh8VvBQka3t6NzBK/exec';

(function () {
  'use strict';

  // Default AlphaX Roles & Registered User Accounts
  const DEFAULT_ROLES = [
    "CEO",
    "Design Engineer",
    "Certified Tuner",
    "Diagnostic & Shipping",
    "Customer Support"
  ];

  // Default Password SHA-256 for "mipassword123"
  const DEFAULT_PASSWORD_HASH = "78b31c2f705d051930bc67198c290c9b1eb92f1379d2a932bcaa85c258d64d77";

  const SEED_STAFF = [
    { name: "Norman Paulino", email: "normsp@gmail.com", role: "Design Engineer", passwordHash: DEFAULT_PASSWORD_HASH, avatar: "NP" },
    { name: "Raymond Ortiz", email: "ankyth@gmail.com", role: "Diagnostic & Shipping", passwordHash: DEFAULT_PASSWORD_HASH, avatar: "RO" },
    { name: "Jose Perez Betancourt", email: "jrpbcc@gmail.com", role: "CEO", passwordHash: DEFAULT_PASSWORD_HASH, avatar: "JP" },
    { name: "Richard Figueroa", email: "Richardfigue1218@gmail.com", role: "Customer Support", passwordHash: DEFAULT_PASSWORD_HASH, avatar: "RF" },
    { name: "Jaime Rodriguez", email: "jrc.jaime@gmail.com", role: "Certified Tuner", passwordHash: DEFAULT_PASSWORD_HASH, avatar: "JR" }
  ];

  // Helper: Compute SHA-256 Password Hash
  async function sha256(message) {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  }

  // API Call Helper
  async function apiCall(action, payload = {}) {
    if (!APPS_SCRIPT_URL || APPS_SCRIPT_URL.includes('YOUR_DEPLOYED_APPS_SCRIPT')) {
      Logger.api(`Offline Mock Mode active (No Apps Script URL configured). Action: '${action}' saved to LocalStorage.`);
      return null;
    }
    Logger.api(`Sending request to live Google Apps Script -> Action: '${action}'`, payload);
    try {
      const resp = await fetch(APPS_SCRIPT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify({ action: action, ...payload })
      }).catch(e => {
        console.warn("Apps Script network bypassed (Offline mode active):", e);
        return null;
      });

      if (!resp || !resp.ok) return null;
      return await resp.json().catch(() => null);
    } catch (err) {
      console.warn("Apps Script API notice:", err);
      return null;
    }
  }

  // SEED INITIAL DATABASE FOR INSTANT ZERO-LATENCY USE
  const SEED_DATA = {
    products: [
      {
            "id": "PROD-UNI-IRON",
            "name": "AlphaECU Iron",
            "category": "universal",
            "make": "Universal",
            "model": "2-Channel Standalone / Piggyback",
            "currentRevision": "Rev 1.3",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$349",
            "jobberPrice": "$280",
            "dealerPrice": "$240",
            "coreRequired": "No",
            "processorArch": "STM32 168MHz BlackPill",
            "channels": "2 Injector / 2 Ignition / VR+Hall",
            "description": "Computadora 2 canales para usar en conjunto con una ECU de f\u00e1brica o independientemente",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/iron_pinout.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/iron_base.bin",
            "stockQty": "17",
            "casesQty": "6"
      },
      {
            "id": "PROD-UNI-COPPER",
            "name": "AlphaECU Copper",
            "category": "universal",
            "make": "Universal",
            "model": "4-Channel Standalone / Piggyback",
            "currentRevision": "Rev 1.4",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$449",
            "jobberPrice": "$360",
            "dealerPrice": "$310",
            "coreRequired": "No",
            "processorArch": "STM32 168MHz BlackPill",
            "channels": "4 Injector / 4 Ignition / VR+Hall / Boost Control",
            "description": "Computadora 4 canales para uso independiente o piggyback",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/copper_pinout.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/copper_base.bin",
            "stockQty": "2",
            "casesQty": "5"
      },
      {
            "id": "PROD-UNI-BRONZE",
            "name": "AlphaECU Bronze",
            "category": "universal",
            "make": "Universal",
            "model": "4-Channel Advanced Dual-Map",
            "currentRevision": "Rev 1.2",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$499",
            "jobberPrice": "$400",
            "dealerPrice": "$350",
            "coreRequired": "No",
            "processorArch": "STM32 168MHz BlackPill",
            "channels": "4 Injector / 4 Ignition / Boost / Launch / Dual Map",
            "description": "Computadora 4 canales avanzada con switch de doble mapa",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/bronze_pinout.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/bronze_base.bin",
            "stockQty": "2",
            "casesQty": "0"
      },
      {
            "id": "PROD-UNI-SILVER",
            "name": "AlphaECU Silver",
            "category": "universal",
            "make": "Universal",
            "model": "6-Channel + Wideband WBO2",
            "currentRevision": "Rev 2.0",
            "statusFlags": [
                  "finalized",
                  "need_corrections"
            ],
            "lifecycleStatus": "active",
            "msrp": "$599",
            "jobberPrice": "$480",
            "dealerPrice": "$420",
            "coreRequired": "No",
            "processorArch": "STM32 168MHz + LSU4.9 Driver",
            "channels": "6 Injector / 6 Ignition / Built-in Wideband LSU 4.9",
            "description": "Computadora 6 canales con wideband integrado",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/silver_pinout.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/silver_base.bin",
            "stockQty": "5",
            "casesQty": "2"
      },
      {
            "id": "PROD-UNI-GOLD",
            "name": "AlphaECU Gold",
            "category": "universal",
            "make": "Universal",
            "model": "8-Channel V8 Standalone",
            "currentRevision": "Rev 2.1",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$999",
            "jobberPrice": "$800",
            "dealerPrice": "$700",
            "coreRequired": "No",
            "processorArch": "STM32 168MHz BlackPill",
            "channels": "8 Injector / 8 Ignition / Dual Wideband / CANBUS",
            "description": "Computadora 8 canales para motores V8 de alto desempe\u00f1o",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/gold_pinout.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/gold_base.bin",
            "stockQty": "5",
            "casesQty": "5"
      },
      {
            "id": "PROD-UNI-PLATINUM",
            "name": "AlphaECU Platinum",
            "category": "universal",
            "make": "Universal",
            "model": "12-Channel V12 / Dual DBW",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "testing_validation"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,999",
            "jobberPrice": "$1,600",
            "dealerPrice": "$1,400",
            "coreRequired": "No",
            "processorArch": "Dual STM32 High-Speed",
            "channels": "12 Injector / 12 Ignition / Dual DBW / 4 VVT / Dual CAN",
            "description": "Computadora 12 canales insignia para motores de 10 y 12 cilindros",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/platinum_pinout.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/platinum_base.bin",
            "stockQty": "3",
            "casesQty": "0"
      },
      {
            "id": "PROD-UNI-GDI4K",
            "name": "AlphaECU 4K GDi",
            "category": "universal",
            "make": "Universal",
            "model": "4-Channel Direct Injection (GDI)",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "testing_validation",
                  "need_engineering_rev"
            ],
            "lifecycleStatus": "obsolete",
            "msrp": "$2,149",
            "jobberPrice": "$1,720",
            "dealerPrice": "$1,500",
            "coreRequired": "No",
            "processorArch": "STM32 + High Voltage 65V Boost",
            "channels": "4 GDi Peak & Hold + High Pressure Pump Control",
            "description": "Computadora 4 canales de Inyecci\u00f3n Directa GDi (Prototipo cancelado / Nunca sali\u00f3 de desarrollo)",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/gdi4k_pinout.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/gdi4k_base.bin",
            "stockQty": "0",
            "casesQty": "0"
      },
      {
            "id": "PROD-UNI-NEO2",
            "name": "AlphaECU 2chan Neo+",
            "category": "universal",
            "make": "Universal",
            "model": "2-Channel Standalone 168MHz",
            "currentRevision": "Rev 1.1",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "obsolete",
            "msrp": "$699",
            "jobberPrice": "$560",
            "dealerPrice": "$490",
            "coreRequired": "No",
            "processorArch": "STM32 168MHz Neo Core",
            "channels": "2 Injector / 2 Ignition / Onboard Bluetooth",
            "description": "Computadora 2 canales 168MHz (L\u00ednea descontinuada)",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/neo2_pinout.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/neo2_base.bin",
            "stockQty": "0",
            "casesQty": "0"
      },
      {
            "id": "PROD-UNI-NEO4",
            "name": "AlphaECU 4chan Neo+",
            "category": "universal",
            "make": "Universal",
            "model": "6-Channel DBW & Dual VVT",
            "currentRevision": "Rev 1.2",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "obsolete",
            "msrp": "$899",
            "jobberPrice": "$720",
            "dealerPrice": "$630",
            "coreRequired": "No",
            "processorArch": "STM32 168MHz Neo Core",
            "channels": "6 Channels / Drive-By-Wire (DBW) / Dual VVT / CANBUS",
            "description": "Computadora 4/6 canales Neo+ (L\u00ednea descontinuada)",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/neo4_pinout.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/neo4_base.bin",
            "stockQty": "0",
            "casesQty": "0"
      },
      {
            "id": "PROD-UNI-BRAINBOARD",
            "name": "AlphaECU Brainboard (Rojo / Blanco)",
            "category": "universal",
            "make": "Universal",
            "model": "Core MCU Processor Board",
            "currentRevision": "Rev 2.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$149",
            "jobberPrice": "$120",
            "dealerPrice": "$100",
            "coreRequired": "N/A",
            "processorArch": "STM32F407 168MHz",
            "channels": "Modular MCU daughterboard for all AlphaECU motherboards",
            "description": "Procesador principal de muchas AlphaECU (Disponible en Brainboard Rojo y Brainboard Blanco)",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/brainboard_pinout.pdf",
            "baseTuneUrl": "",
            "stockQty": "70",
            "casesQty": "N/A"
      },
      {
            "id": "PROD-BMW-E30M20",
            "name": "BMW E30 M20",
            "category": "plugin",
            "make": "BMW",
            "model": "E30 325i M20B25 1987-1991 (Motronic 1.1/1.3)",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "No",
            "processorArch": "Brainboard STM32",
            "channels": "6-Cylinder Wasted Spark / 60-2 VR Trigger / Idle ICV",
            "description": "Computadora PNP para BMW M20",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/bmw_e30_m20.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/m20b25_base.bin",
            "stockQty": "2",
            "casesQty": "1"
      },
      {
            "id": "PROD-BMW-E36M50",
            "name": "BMW E36 M50",
            "category": "plugin",
            "make": "BMW",
            "model": "E36 325i M50B25 Non-Vanos & Vanos",
            "currentRevision": "Rev 1.4",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "Shared Case (2)",
            "processorArch": "Brainboard STM32",
            "channels": "6-Cylinder Sequential / Single Vanos / Factory Idle ICV",
            "description": "Computadora PNP para BMW M50 (caja compartida con M52)",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/bmw_e36_m50.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/m50b25_base.bin",
            "stockQty": "3",
            "casesQty": "2"
      },
      {
            "id": "PROD-BMW-E36M52",
            "name": "BMW E36 M52",
            "category": "plugin",
            "make": "BMW",
            "model": "E36 328i/M3 M52B28 / S52 (OBD2)",
            "currentRevision": "Rev 1.4",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "Shared Case",
            "processorArch": "Brainboard STM32",
            "channels": "6-Cylinder Sequential / Dual Knock / Factory Temp Gauge",
            "description": "Computadora PNP para BMW M52 (caja compartida con M50)",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/bmw_e36_m52.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/m52b28_base.bin",
            "stockQty": "2",
            "casesQty": "2"
      },
      {
            "id": "PROD-BMW-E46M54",
            "name": "BMW E46 M54 (MS43)",
            "category": "plugin",
            "make": "BMW",
            "model": "E46 325i/330i M54B25/M54B30",
            "currentRevision": "Rev 1.1",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,500",
            "jobberPrice": "$1,200",
            "dealerPrice": "$1,050",
            "coreRequired": "2",
            "processorArch": "Brainboard STM32",
            "channels": "Dual Vanos / DBW / CANBUS Instrument Cluster Integration",
            "description": "Computadora PNP para BMW M54",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/bmw_e46_m54.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/m54b30_base.bin",
            "stockQty": "4",
            "casesQty": "2"
      },
      {
            "id": "PROD-CHEV-VETTEC6",
            "name": "Chevy Corvette C6",
            "category": "plugin",
            "make": "Chevrolet",
            "model": "Corvette C6 LS2 / LS3 / LS7 6.0L-7.0L",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,900",
            "jobberPrice": "$1,520",
            "dealerPrice": "$1,330",
            "coreRequired": "No",
            "processorArch": "Brainboard Dual Core",
            "channels": "58X Crank Trigger / Dual DBW / V8 Sequential / Full CANBUS",
            "description": "Computadora PNP para Chevrolet Corvette C6 LS2/LS3",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/chevy_corvette_c6.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/ls3_c6_base.bin",
            "stockQty": "2",
            "casesQty": "1"
      },
      {
            "id": "PROD-CHEV-CAMAROLS",
            "name": "Chevy Camaro Fifth Gen LS",
            "category": "plugin",
            "make": "Chevrolet",
            "model": "Camaro SS 6.2L LS3 / L99 Gen 5",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$2,999",
            "jobberPrice": "$2,400",
            "dealerPrice": "$2,100",
            "coreRequired": "No",
            "processorArch": "Brainboard Dual Core",
            "channels": "V8 Sequential / DBW Throttle / VVT / Active Fuel Management delete",
            "description": "Computadora PNP para Chevrolet Camaro 6.2",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/chevy_camaro_ls.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/camaro_ls3_base.bin",
            "stockQty": "1",
            "casesQty": "0"
      },
      {
            "id": "PROD-DODGE-HEMIGPEC2A",
            "name": "Dodge Hemi GPEC2A",
            "category": "plugin",
            "make": "Dodge",
            "model": "Hemi 5.7L / 6.2L Hellcat / 6.4L 392 ScatPack",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "testing_validation",
                  "need_engineering_rev"
            ],
            "lifecycleStatus": "active",
            "msrp": "$2,999",
            "jobberPrice": "$2,400",
            "dealerPrice": "$2,100",
            "coreRequired": "No",
            "processorArch": "High-Speed Tri-Core Architecture",
            "channels": "Dual DBW / Variable Cam Timing VCT / Supercharger Bypass / CAN Gateway",
            "description": "Computadora Plugin para Dodge Hemi 5.7/6.2/6.4 GPEC2A",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/dodge_hemi_gpec2a.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/hemi_64_base.bin",
            "stockQty": "1",
            "casesQty": "0"
      },
      {
            "id": "PROD-FORD-FOX8695",
            "name": "Ford Mustang 86-95 (Foxbody / SN95)",
            "category": "plugin",
            "make": "Ford",
            "model": "Mustang 5.0 302 / 3.8 V6 1986-1995",
            "currentRevision": "Rev 2.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "1 (shared foxbody)",
            "processorArch": "Brainboard STM32",
            "channels": "PNP TFI Ignition Module / 8 Injectors / Mass Air or Speed Density",
            "description": "Computadora PNP para Mustang 302/V6 (comparte caja foxbody)",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/ford_foxbody_302.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/foxbody_302_base.bin",
            "stockQty": "3",
            "casesQty": "1"
      },
      {
            "id": "PROD-FORD-SN9604",
            "name": "Ford Mustang 96-04 (4.6 2V)",
            "category": "plugin",
            "make": "Ford",
            "model": "Mustang 4.6L Modular 2V / V6 1996-2004",
            "currentRevision": "Rev 1.3",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "1 (shared foxbody)",
            "processorArch": "Brainboard STM32",
            "channels": "PNP 4.6 2V Modular EDIS / Wasted Spark / Cluster integration",
            "description": "Computadora PNP para Mustang 4.6/V6 1996-1998 y 1999-2004",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/ford_mustang_46.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/mustang_46_base.bin",
            "stockQty": "4",
            "casesQty": "1"
      },
      {
            "id": "PROD-FORD-S1973V",
            "name": "Ford Mustang 05-11 (4.6 3V)",
            "category": "plugin",
            "make": "Ford",
            "model": "Mustang GT 4.6L 3-Valve S197 2005-2010",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,500",
            "jobberPrice": "$1,200",
            "dealerPrice": "$1,050",
            "coreRequired": "No",
            "processorArch": "Brainboard STM32 + VVT Driver",
            "channels": "Dual VCT / Drive-By-Wire / CMCV Runner Control / CAN Cluster",
            "description": "Computadora Plugin para Mustang 4.6 3V",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/ford_mustang_46_3v.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/mustang_3v_base.bin",
            "stockQty": "2",
            "casesQty": "1"
      },
      {
            "id": "PROD-FORD-S197COYOTE",
            "name": "Ford Mustang 12-14 (S197 Coyote 5.0 4V)",
            "category": "plugin",
            "make": "Ford",
            "model": "Mustang GT Coyote 5.0 4V 2011-2014",
            "currentRevision": "Rev A",
            "statusFlags": [
                  "finalized",
                  "need_corrections"
            ],
            "lifecycleStatus": "active",
            "msrp": "$2,000",
            "jobberPrice": "$1,600",
            "dealerPrice": "$1,400",
            "coreRequired": "No",
            "processorArch": "Brainboard STM32 + Ti VVT Driver",
            "channels": "Quad Ti-VCT Cam Control / DBW / CAN Gateway",
            "description": "Computadora Plugin para Mustang 5.0 4V Coyote 2012-2014",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/ford_s197_coyote.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/s197_coyote_base.bin",
            "stockQty": "2",
            "casesQty": "1"
      },
      {
            "id": "PROD-FORD-S550",
            "name": "Ford Mustang 15-17 (S550 Coyote V1/V2)",
            "category": "plugin",
            "make": "Ford",
            "model": "Mustang GT Coyote 5.0 4V S550 2015-2017",
            "currentRevision": "Rev 2.0",
            "statusFlags": [
                  "finalized",
                  "need_corrections"
            ],
            "lifecycleStatus": "active",
            "msrp": "$2,999",
            "jobberPrice": "$2,400",
            "dealerPrice": "$2,100",
            "coreRequired": "No",
            "processorArch": "Brainboard Dual Core",
            "channels": "Quad VVT / Direct Injection Secondary / Full CANBUS",
            "description": "Computadora Plugin para Mustang 5.0 4V 2015-2017 S550",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/ford_s550.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/s550_coyote_base.bin",
            "stockQty": "2",
            "casesQty": "1"
      },
      {
            "id": "PROD-HON-8THGEN",
            "name": "Honda Civic 8th Gen (FG2/FA5)",
            "category": "plugin",
            "make": "Honda",
            "model": "Civic 8th Gen K20Z3 2006-2011",
            "currentRevision": "Rev 1.1",
            "statusFlags": [
                  "finalized",
                  "need_corrections"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,500",
            "jobberPrice": "$1,200",
            "dealerPrice": "$1,050",
            "coreRequired": "3",
            "processorArch": "Brainboard STM32",
            "channels": "Full PNP / DBW / CANBUS Gauges / EPS Assist",
            "description": "Computadora PNP para Honda Civic Si 8va Generaci\u00f3n K20Z3 con ETB y cluster funcional",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/honda_8thgen.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/k20z3_8thgen_base.bin",
            "stockQty": "9",
            "casesQty": "3"
      },
      {
            "id": "PROD-HON-S2000",
            "name": "Honda S2000 AP1",
            "category": "plugin",
            "make": "Honda",
            "model": "S2000 AP1 F20C 2000-2005",
            "currentRevision": "Rev 1.3",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "4",
            "processorArch": "Brainboard STM32",
            "channels": "Full PNP / VTEC Control / Factory Cluster Temp & Tach",
            "description": "Computadora PNP para Honda S2000 AP1 F20C",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/honda_s2000_ap1.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/s2000_ap1_base.bin",
            "stockQty": "3",
            "casesQty": "4"
      },
      {
            "id": "PROD-HON-EP3RSX",
            "name": "Honda EP3 / RSX (Serie K Swap)",
            "category": "plugin",
            "make": "Honda",
            "model": "EP3 Civic Si / RSX / K-Swap EG/EK",
            "currentRevision": "Rev 1.2",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,000",
            "jobberPrice": "$800",
            "dealerPrice": "$700",
            "coreRequired": "2 (Core: 2)",
            "processorArch": "Brainboard STM32",
            "channels": "PNP K-Series K20A/A2/A3 / VTC / VTEC",
            "description": "Computadora PNP para Honda Serie K EG/RSX",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/honda_kseries_ep3.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/k20a2_base.bin",
            "stockQty": "2",
            "casesQty": "2"
      },
      {
            "id": "PROD-HON-SERIEB",
            "name": "Honda Serie B P28",
            "category": "plugin",
            "make": "Honda",
            "model": "Civic/Integra B16/B18/B20 (OBD1)",
            "currentRevision": "Rev 1.4",
            "statusFlags": [
                  "finalized",
                  "need_corrections"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "5",
            "processorArch": "Brainboard STM32",
            "channels": "PNP OBD1 P28 Harness / VTEC / Hall or VR Distributor",
            "description": "Computadora PNP para Honda Serie B con rabiza P28",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/honda_p28.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/b18c_base.bin",
            "stockQty": "16",
            "casesQty": "5"
      },
      {
            "id": "PROD-HON-KRUSO",
            "name": "Honda Serie K EG/RSX Ruso",
            "category": "plugin",
            "make": "Honda",
            "model": "Serie K EG/EK Swap Harness Ruso",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,000",
            "jobberPrice": "$800",
            "dealerPrice": "$700",
            "coreRequired": "No",
            "processorArch": "Brainboard STM32",
            "channels": "Custom Russian pinout architecture for K-Swap",
            "description": "Computadora PNP para Honda Serie K EG/RSX Ruso",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/honda_k_ruso.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/k20_ruso_base.bin",
            "stockQty": "1",
            "casesQty": "0"
      },
      {
            "id": "PROD-HON-KDESIGNV1",
            "name": "K Series Alpha Design V1",
            "category": "plugin",
            "make": "Honda",
            "model": "K-Series Custom Integrated Architecture",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "testing_validation",
                  "need_engineering_rev"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,200",
            "jobberPrice": "$960",
            "dealerPrice": "$840",
            "coreRequired": "No",
            "processorArch": "Integrated STM32 Single Board",
            "channels": "Direct K20/K24 Integrated PCB / Dual Wideband",
            "description": "Nueva arquitectura integrada Single-Board para Honda K-Series",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/kseries_alphav1.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/kseries_v1_base.bin",
            "stockQty": "2",
            "casesQty": "0"
      },
      {
            "id": "PROD-HYU-ACCENT1",
            "name": "Hyundai Accent Gen1 (1994-1999)",
            "category": "plugin",
            "make": "Hyundai",
            "model": "Accent 1.5L SOHC/DOHC 1994-1999",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "deprecated",
            "msrp": "$600",
            "jobberPrice": "$480",
            "dealerPrice": "$420",
            "coreRequired": "No",
            "processorArch": "Brainboard STM32",
            "channels": "4-Cylinder Sequential / Wasted Spark / Factory Idle ICV",
            "description": "Computadora Plug and Play para Hyundai Accent 1.5 1994-1999",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/hyundai_accent_gen1.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/accent15_base.bin",
            "stockQty": "0",
            "casesQty": "0"
      },
      {
            "id": "PROD-HYU-ACCENT2",
            "name": "Hyundai Accent Gen2 (2000-2006)",
            "category": "plugin",
            "make": "Hyundai",
            "model": "Accent 1.5L/1.6L Alpha 2000-2006",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "deprecated",
            "msrp": "$600",
            "jobberPrice": "$480",
            "dealerPrice": "$420",
            "coreRequired": "No",
            "processorArch": "Brainboard STM32",
            "channels": "4-Cylinder Sequential / 60-2 VR Trigger / Factory Tach",
            "description": "Computadora Plug and Play para Hyundai Accent 1.5 2000-2006",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/hyundai_accent_gen2.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/accent16_base.bin",
            "stockQty": "0",
            "casesQty": "0"
      },
      {
            "id": "PROD-HYU-GENESIS20T",
            "name": "Hyundai Genesis Coupe 2.0T",
            "category": "plugin",
            "make": "Hyundai",
            "model": "Genesis Coupe 2.0T Theta 2010-2014",
            "currentRevision": "Rev 1.3",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,500",
            "jobberPrice": "$1,200",
            "dealerPrice": "$1,050",
            "coreRequired": "N/A",
            "processorArch": "Brainboard STM32",
            "channels": "Dual CVVT / DBW / Boost Solenoid / CANBUS Gauges",
            "description": "Computadora Plug and Play para Hyundai Genesis Coupe 2.0T 2010-2014",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/hyundai_genesis_20t.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/genesis_20t_base.bin",
            "stockQty": "12",
            "casesQty": "0"
      },
      {
            "id": "PROD-HYU-TIBURONB1",
            "name": "Hyundai Tiburon Beta1",
            "category": "plugin",
            "make": "Hyundai",
            "model": "Tiburon 2.0L Beta 1 1997-2001",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "deprecated",
            "msrp": "$600",
            "jobberPrice": "$480",
            "dealerPrice": "$420",
            "coreRequired": "1",
            "processorArch": "Brainboard STM32",
            "channels": "4-Cylinder / Wasted Spark / Idle PWM",
            "description": "Computadora Plug and Play para Hyundai Tiburon 2.0 1997-2001",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/hyundai_tiburon_b1.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/tiburon_b1_base.bin",
            "stockQty": "1",
            "casesQty": "1"
      },
      {
            "id": "PROD-HYU-TIBURONB2",
            "name": "Hyundai Tiburon Beta2",
            "category": "plugin",
            "make": "Hyundai",
            "model": "Tiburon 2.0L Beta 2 VVT 2003-2007",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "deprecated",
            "msrp": "$700",
            "jobberPrice": "$560",
            "dealerPrice": "$490",
            "coreRequired": "1",
            "processorArch": "Brainboard STM32",
            "channels": "4-Cylinder / CVVT Vane Control / Idle ICV",
            "description": "Computadora Plug and Play para Hyundai Tiburon 2.0 2003-2007",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/hyundai_tiburon_b2.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/tiburon_b2_base.bin",
            "stockQty": "0",
            "casesQty": "1"
      },
      {
            "id": "PROD-HYU-TIBURONV6",
            "name": "Hyundai Tiburon V6 (2.7L Delta)",
            "category": "plugin",
            "make": "Hyundai",
            "model": "Tiburon GT 2.7L Delta V6 2003-2007",
            "currentRevision": "Rev 1.2",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "3",
            "processorArch": "Brainboard STM32",
            "channels": "V6 Sequential Injection / Wasted Spark / Idle ICV",
            "description": "Computadora Plug and Play para Hyundai Tiburon 2.7 2003-2007",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/hyundai_tiburon_v6.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/tiburon_v6_base.bin",
            "stockQty": "8",
            "casesQty": "3"
      },
      {
            "id": "PROD-KIA-RIO2008",
            "name": "Kia Rio 2008 (Beta/Alpha)",
            "category": "plugin",
            "make": "Kia",
            "model": "Kia Rio 1.6L Alpha/Beta II 2006-2011",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "deprecated",
            "msrp": "$600",
            "jobberPrice": "$480",
            "dealerPrice": "$420",
            "coreRequired": "No",
            "processorArch": "Brainboard STM32",
            "channels": "4-Cylinder Sequential / VVT Cam Sync",
            "description": "Computadora para Hyundai/Kia last beta engine",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/kia_rio_2008.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/kia_rio_base.bin",
            "stockQty": "0",
            "casesQty": "0"
      },
      {
            "id": "PROD-MAZ-MIATANA",
            "name": "Mazda Miata NA 1989-96",
            "category": "plugin",
            "make": "Mazda",
            "model": "Miata NA 1.6L B6-ZE / 1.8L BP-4W 1989-1996",
            "currentRevision": "Rev 2.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "3",
            "processorArch": "Brainboard STM32",
            "channels": "PNP CAS Optical / Wasted Spark / Factory AC switch",
            "description": "Computadora PNP para Mazda Miata NA 1.6/1.8",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/mazda_miata_na.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/miata_na_base.bin",
            "stockQty": "15",
            "casesQty": "3"
      },
      {
            "id": "PROD-MAZ-MIATANB1",
            "name": "Mazda Miata NB 1999-00",
            "category": "plugin",
            "make": "Mazda",
            "model": "Miata NB1 1.8L BP-4W 1999-2000",
            "currentRevision": "Rev 2.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "1",
            "processorArch": "Brainboard STM32",
            "channels": "PNP NB Trigger / Wasted Spark / Factory Alternator Field Control",
            "description": "Computadora PNP para Mazda Miata NB 1.8 1999-2000",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/mazda_miata_nb1.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/miata_nb1_base.bin",
            "stockQty": "2",
            "casesQty": "2"
      },
      {
            "id": "PROD-MAZ-MIATANB2",
            "name": "Mazda Miata NB2 00-02 (VVT)",
            "category": "plugin",
            "make": "Mazda",
            "model": "Miata NB2 1.8L BP-Z3 VVT 2000-2005",
            "currentRevision": "Rev 2.1",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "1",
            "processorArch": "Brainboard STM32",
            "channels": "PNP NB Trigger / VVT Cam Angle Control / Alternator Field Control",
            "description": "Computadora PNP para Mazda Miata NB 1.8 2000-2002 con VVT",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/mazda_miata_nb2.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/miata_nb2_base.bin",
            "stockQty": "4",
            "casesQty": "2"
      },
      {
            "id": "PROD-MAZ-PROTEGE",
            "name": "Mazda Protege (1.8L / 2.0L)",
            "category": "plugin",
            "make": "Mazda",
            "model": "Protege / Protege5 1.8L FP-DE / 2.0L FS-DE",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "deprecated",
            "msrp": "$750",
            "jobberPrice": "$600",
            "dealerPrice": "$525",
            "coreRequired": "No",
            "processorArch": "Brainboard STM32",
            "channels": "4-Cylinder Sequential / Wasted Spark / Idle ICV",
            "description": "Computadora PNP para Mazda Protege / Protege5",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/mazda_protege.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/protege_fs_base.bin",
            "stockQty": "0",
            "casesQty": "0"
      },
      {
            "id": "PROD-MINI-R53",
            "name": "Mini Cooper R53 Supercharger",
            "category": "plugin",
            "make": "Mini",
            "model": "Mini Cooper S 1.6L Supercharged W11 2002-2006",
            "currentRevision": "Rev 1.3",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,500",
            "jobberPrice": "$1,200",
            "dealerPrice": "$1,050",
            "coreRequired": "2",
            "processorArch": "Brainboard STM32",
            "channels": "DBW Throttle / Supercharger Bypass / Full CANBUS Dash",
            "description": "Computadora PNP para Mini Cooper Supercharger 1.6",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/mini_r53.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/mini_r53_base.bin",
            "stockQty": "4",
            "casesQty": "2"
      },
      {
            "id": "PROD-MITS-3000GT",
            "name": "Mitsubishi 3000GT / Stealth (6G72)",
            "category": "plugin",
            "make": "Mitsubishi",
            "model": "3000GT / Stealth 3.0L V6 6G72 DOHC Turbo / NA",
            "currentRevision": "Rev 1.2",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "3",
            "processorArch": "Brainboard STM32",
            "channels": "6-Cylinder / Optical / Hall Cam-Crank Sync / Dual Turbo Wastegate",
            "description": "Computadora PNP para Mitsubishi 3000GT / Stealth 6G72",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/mits_3000gt.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/3000gt_6g72_base.bin",
            "stockQty": "5",
            "casesQty": "3"
      },
      {
            "id": "PROD-MITS-ECLIPSE6G75",
            "name": "Mitsubishi Eclipse 06+ (6G75 3.8L)",
            "category": "plugin",
            "make": "Mitsubishi",
            "model": "Eclipse 4G 3.8L V6 6G75 MIVEC 2006-2012",
            "currentRevision": "Rev 1.2",
            "statusFlags": [
                  "finalized",
                  "need_corrections"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "No",
            "processorArch": "Brainboard STM32",
            "channels": "V6 MIVEC / DBW / Crank-Cam Sync / Parallel 1K Resistor rework",
            "description": "Computadora PNP para Mitsubishi Eclipse 4G 3.8 6G75 2006+",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/mits_eclipse_38.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/eclipse_6g75_base.bin",
            "stockQty": "4",
            "casesQty": "3"
      },
      {
            "id": "PROD-MITS-LANCER4B",
            "name": "Mitsubishi Lancer 4Bxx (2008+)",
            "category": "plugin",
            "make": "Mitsubishi",
            "model": "Lancer 2.0L/2.4L 4B11 / 4B12 2008+",
            "currentRevision": "Rev 1.3",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,500",
            "jobberPrice": "$1,200",
            "dealerPrice": "$1,050",
            "coreRequired": "Core or +$50",
            "processorArch": "Brainboard STM32",
            "channels": "PNP 4B11 / DBW / MIVEC / CANBUS Dash Integration",
            "description": "Computadora PNP para Lancer 2008+ motor 4b11 y 4b12",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/mits_4b11.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/4b11_base.bin",
            "stockQty": "14",
            "casesQty": "5"
      },
      {
            "id": "PROD-MITS-MRMD",
            "name": "Mitsubishi MR/MD (Tecnica / Evo 4-8)",
            "category": "plugin",
            "make": "Mitsubishi",
            "model": "Tecnica 97-02 / Lancer Evo 4-8 / Mirage",
            "currentRevision": "Rev 1.3 (V13)",
            "statusFlags": [
                  "finalized",
                  "need_corrections"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "5",
            "processorArch": "Brainboard STM32",
            "channels": "PNP 4G93/4G63 / Factory Stepper Idle / VR+Hall",
            "description": "Computadora PNP para Tecnica 97-2002, Evolution 4-8, varias otras",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/mits_tecnica.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/4g93_tecnica_base.bin",
            "stockQty": "17",
            "casesQty": "5"
      },
      {
            "id": "PROD-MITS-RALLIART",
            "name": "Mitsubishi Ralliart 04-06",
            "category": "plugin",
            "make": "Mitsubishi",
            "model": "Lancer Ralliart 2.4L 4G69 MIVEC 2004-2006",
            "currentRevision": "Rev 1.1",
            "statusFlags": [
                  "finalized",
                  "need_corrections"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,500",
            "jobberPrice": "$1,200",
            "dealerPrice": "$1,050",
            "coreRequired": "Core or +$100",
            "processorArch": "Brainboard STM32",
            "channels": "PNP 4G69 / DBW / MIVEC Variable Valve Lift",
            "description": "Computadora PNP para Lancer Ralliart 2004-2006 4G69",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/mits_ralliart.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/4g69_ralliart_base.bin",
            "stockQty": "6",
            "casesQty": "0"
      },
      {
            "id": "PROD-MITS-MIRAGEG4",
            "name": "Mitsubishi Mirage G4 (3A92)",
            "category": "plugin",
            "make": "Mitsubishi",
            "model": "Mirage / Attrage G4 1.2L 3A92 3-Cylinder",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$600",
            "jobberPrice": "$480",
            "dealerPrice": "$420",
            "coreRequired": "No",
            "processorArch": "Brainboard STM32",
            "channels": "3-Cylinder Sequential / MIVEC VVT / DBW Throttle",
            "description": "Computadora PNP para Mitsubishi Mirage G4 3A92",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/mits_mirage_g4.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/mirage_g4_base.bin",
            "stockQty": "0",
            "casesQty": "0"
      },
      {
            "id": "PROD-NIS-SKYLINE",
            "name": "Nissan Skyline R32/R33/R34 (GTT/GTR)",
            "category": "plugin",
            "make": "Nissan",
            "model": "Skyline R32 / R33 / R34 RB20 / RB25 / RB26DETT",
            "currentRevision": "Rev 1.1",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,200",
            "jobberPrice": "$960",
            "dealerPrice": "$840",
            "coreRequired": "No",
            "processorArch": "Brainboard STM32",
            "channels": "6-Cylinder Sequential / CAS Optical / VTC / Twin Turbo Boost",
            "description": "Computadora PNP para Nissan Skyline R32, R33, R34 GTT y GTR con motor RB20/25/26",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/nissan_skyline_rb.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/skyline_rb26_base.bin",
            "stockQty": "4",
            "casesQty": "2"
      },
      {
            "id": "PROD-NIS-350Z",
            "name": "Nissan 350Z (VQ35DE)",
            "category": "plugin",
            "make": "Nissan",
            "model": "350Z / G35 VQ35DE 2003-2006",
            "currentRevision": "Rev 1.2",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,500",
            "jobberPrice": "$1,200",
            "dealerPrice": "$1,050",
            "coreRequired": "N/A",
            "processorArch": "Brainboard STM32",
            "channels": "Dual VTC / Drive-By-Wire / Full CANBUS Cluster Integration",
            "description": "Computadora Plug and Play para Nissan 350Z VQ35DE",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/nissan_350z.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/350z_vq35de_base.bin",
            "stockQty": "3",
            "casesQty": "0"
      },
      {
            "id": "PROD-NIS-S131415",
            "name": "Nissan S13/14/15 (SR20DET)",
            "category": "plugin",
            "make": "Nissan",
            "model": "Silvia / 240SX SR20DET / KA24DE",
            "currentRevision": "Rev 1.4",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "2",
            "processorArch": "Brainboard STM32",
            "channels": "CAS Optical Trigger / VVT Cam Switch / Boost Control",
            "description": "Computadora PNP para Nissan SR20DET y KA24DE",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/nissan_sr20det.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/sr20det_base.bin",
            "stockQty": "6",
            "casesQty": "2"
      },
      {
            "id": "PROD-SUB-RSEJ20",
            "name": "Subaru RS Ej20 2000-07",
            "category": "plugin",
            "make": "Subaru",
            "model": "Impreza RS 2.5L / EJ20 N/A 2000-2007",
            "currentRevision": "Rev 1.1",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$499",
            "jobberPrice": "$400",
            "dealerPrice": "$350",
            "coreRequired": "No",
            "processorArch": "Brainboard STM32",
            "channels": "6/7 Subaru Trigger / Wasted Spark / Idle PWM",
            "description": "Computadora PNP para Subaru RS EJ20 2000-2007",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/subaru_rs_ej20.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/ej20_na_base.bin",
            "stockQty": "2",
            "casesQty": "0"
      },
      {
            "id": "PROD-SUB-WRXEJ20",
            "name": "Subaru WRX Ej20 2000-07",
            "category": "plugin",
            "make": "Subaru",
            "model": "Impreza WRX Turbo EJ205 2000-2007",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "No",
            "processorArch": "Brainboard STM32",
            "channels": "AVCS Intake VVT / Wasted Spark / Boost Control Solenoid",
            "description": "Computadora PNP para Subaru WRX EJ20 2000-2007",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/subaru_wrx_ej20.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/wrx_ej205_base.bin",
            "stockQty": "1",
            "casesQty": "0"
      },
      {
            "id": "PROD-SUB-WRXSTI",
            "name": "Subaru WRX STi 04-06 (EJ207/257)",
            "category": "plugin",
            "make": "Subaru",
            "model": "WRX STi EJ257 / EJ207 2004-2006",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,000",
            "jobberPrice": "$800",
            "dealerPrice": "$700",
            "coreRequired": "No",
            "processorArch": "Brainboard STM32",
            "channels": "Dual AVCS / Drive-By-Wire / Dual Knock / Intercooler Spray",
            "description": "Computadora PNP para Subaru WRX EJ207/EJ257 2004-2006",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/subaru_wrx_sti.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/sti_ej257_base.bin",
            "stockQty": "1",
            "casesQty": "0"
      },
      {
            "id": "PROD-TOY-COR9702",
            "name": "Toyota Corolla 97-02 (4A/7A)",
            "category": "plugin",
            "make": "Toyota",
            "model": "Corolla 1.6L 4A-FE / 1.8L 7A-FE 1997-2002",
            "currentRevision": "Rev 1.2",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "2",
            "processorArch": "Brainboard STM32",
            "channels": "Distributor Hall / Wasted Spark / Idle ICV",
            "description": "Computadora PNP para Toyota Corolla 97-02 4AFE/7AFE (incluye 7A-FE)",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/toyota_corolla_9702.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/7afe_base.bin",
            "stockQty": "15",
            "casesQty": "2"
      },
      {
            "id": "PROD-TOY-COR0304",
            "name": "Toyota Corolla 03-04 (1ZZ)",
            "category": "plugin",
            "make": "Toyota",
            "model": "Corolla / Matrix 1.8L 1ZZ-FE Cable Throttle 2003-2004",
            "currentRevision": "Rev 1.2",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "Shared Case",
            "processorArch": "Brainboard STM32",
            "channels": "36-2 VR Crank / VVT-i Cam / Idle PWM",
            "description": "Computadora PNP para Toyota Corolla 03-04 1ZZ",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/toyota_corolla_0304.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/1zz_0304_base.bin",
            "stockQty": "5",
            "casesQty": "2"
      },
      {
            "id": "PROD-TOY-2ZZ0506",
            "name": "Toyota Corolla/Matrix XRS 05-06",
            "category": "plugin",
            "make": "Toyota",
            "model": "Corolla / Matrix XRS 2ZZ-GE (DBW 05-06)",
            "currentRevision": "Rev 1.5",
            "statusFlags": [
                  "finalized",
                  "need_corrections"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "5 (Shared with Matrix)",
            "processorArch": "Brainboard STM32",
            "channels": "PNP 2ZZ-GE / DBW / VVTL-i Cam Lift switch",
            "description": "Computadora PNP para Toyota Corolla y Matrix 2ZZ 05-06",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/toyota_2zz_0506.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/2zz_0506_base.bin",
            "stockQty": "10",
            "casesQty": "5"
      },
      {
            "id": "PROD-TOY-MATRIX2ZZ",
            "name": "Toyota Matrix 2zz 03-04",
            "category": "plugin",
            "make": "Toyota",
            "model": "Matrix XRS / Celica GTS 2ZZ-GE Cable Throttle 2003-2004",
            "currentRevision": "Rev 1.2",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "5 (Shared with Corolla)",
            "processorArch": "Brainboard STM32",
            "channels": "PNP 2ZZ-GE Cable Throttle / Lift VVL",
            "description": "Computadora PNP para Toyota Matrix 2003-2004",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/toyota_2zz_0304.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/2zz_0304_base.bin",
            "stockQty": "4",
            "casesQty": "5"
      },
      {
            "id": "PROD-TOY-COR0712",
            "name": "Toyota Corolla 07-12 (2ZR-FE)",
            "category": "plugin",
            "make": "Toyota",
            "model": "Corolla 1.8L 2ZR-FE Dual VVT-i 2007-2012",
            "currentRevision": "Rev 1.1",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,500",
            "jobberPrice": "$1,200",
            "dealerPrice": "$1,050",
            "coreRequired": "No",
            "processorArch": "Brainboard STM32",
            "channels": "Dual VVT-i / Drive-By-Wire / Full CANBUS Instrument Integration",
            "description": "Computadora PNP para Toyota Corolla 07-12 2ZR",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/toyota_corolla_0712.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/2zr_corolla_base.bin",
            "stockQty": "2",
            "casesQty": "0"
      },
      {
            "id": "PROD-TOY-ECHO1NZ",
            "name": "Toyota Echo 1NZ",
            "category": "plugin",
            "make": "Toyota",
            "model": "Echo / Yaris 1NZ-FE 1.5L 2000-2005",
            "currentRevision": "Rev 1.3",
            "statusFlags": [
                  "finalized",
                  "need_corrections"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "5 (Uses same as XRS)",
            "processorArch": "Brainboard STM32",
            "channels": "PNP 1NZ-FE / VVT-i Control / Idle Valve PWM",
            "description": "Computadora PNP para Toyota Echo 1NZ",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/toyota_echo_1nz.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/1nz_base.bin",
            "stockQty": "5",
            "casesQty": "5"
      },
      {
            "id": "PROD-TOY-TERCEL95",
            "name": "Toyota Tercel 95 (2 plugs)",
            "category": "plugin",
            "make": "Toyota",
            "model": "Tercel 1.5L 5E-FE 2-Plug Harness 1995",
            "currentRevision": "Rev 1.2",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "4",
            "processorArch": "Brainboard STM32",
            "channels": "Distributor Ignition / Batch Fire / Idle PWM",
            "description": "Computadora PNP para Toyota Tercel 95 (2 plugs)",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/toyota_tercel_95.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/5efe_95_base.bin",
            "stockQty": "5",
            "casesQty": "4"
      },
      {
            "id": "PROD-TOY-TERCEL9699",
            "name": "Toyota Tercel 96-99 (3 plugs)",
            "category": "plugin",
            "make": "Toyota",
            "model": "Tercel 1.5L 5E-FE 3-Plug Harness 1996-1999",
            "currentRevision": "Rev 1.2",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "4",
            "processorArch": "Brainboard STM32",
            "channels": "Distributor Ignition / Wasted Spark ready / JJ K-Series PNP compatible",
            "description": "Computadora PNP para Toyota Tercel 96-99 (3 plugs)",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/toyota_tercel_9699.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/5efe_9699_base.bin",
            "stockQty": "10",
            "casesQty": "4"
      },
      {
            "id": "PROD-TOY-YARIS0812",
            "name": "Toyota Yaris 08-12/Corolla XRS 09",
            "category": "plugin",
            "make": "Toyota",
            "model": "Yaris 1NZ-FE / Corolla XRS 2.4L 2AZ-FE 2008-2012",
            "currentRevision": "Rev 1.1",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,500",
            "jobberPrice": "$1,200",
            "dealerPrice": "$1,050",
            "coreRequired": "0**",
            "processorArch": "Brainboard STM32",
            "channels": "DBW Throttle / VVT-i / Full CANBUS Dash",
            "description": "Computadora PNP para Toyota Yaris 08-12 y Corolla XRS 09 2.4L",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/toyota_yaris_0812.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/2az_xrs09_base.bin",
            "stockQty": "3",
            "casesQty": "0"
      },
      {
            "id": "PROD-SCION-TC1G",
            "name": "Scion TC 05-07 (TC 1g)",
            "category": "plugin",
            "make": "Toyota",
            "model": "Scion tC 2.4L 2AZ-FE 2005-2007",
            "currentRevision": "Rev 1.5",
            "statusFlags": [
                  "finalized",
                  "need_corrections"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,500",
            "jobberPrice": "$1,200",
            "dealerPrice": "$1,050",
            "coreRequired": "3",
            "processorArch": "Brainboard STM32",
            "channels": "PNP 2AZ-FE / DBW / AC Request Jumper",
            "description": "Computadora PNP para Scion TC 05-07",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/scion_tc1.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/2az_tc1_base.bin",
            "stockQty": "3",
            "casesQty": "3"
      },
      {
            "id": "PROD-SCION-TC0811",
            "name": "Scion TC 2008-11",
            "category": "plugin",
            "make": "Toyota",
            "model": "Scion tC 2.4L 2AZ-FE 2008-2011 (TC 1.5)",
            "currentRevision": "Rev 1.5",
            "statusFlags": [
                  "finalized",
                  "need_corrections"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,500",
            "jobberPrice": "$1,200",
            "dealerPrice": "$1,050",
            "coreRequired": "4",
            "processorArch": "Brainboard STM32",
            "channels": "PNP 2AZ-FE / Jumper Alignment Update",
            "description": "Computadora PNP para Scion TC 2008-11",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/scion_tc08.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/2az_tc08_base.bin",
            "stockQty": "4",
            "casesQty": "4"
      },
      {
            "id": "PROD-SCION-TC2",
            "name": "Scion TC 2",
            "category": "plugin",
            "make": "Toyota",
            "model": "Scion tC 2.5L 2AR-FE Gen 2 2011-2016",
            "currentRevision": "Rev 1.2",
            "statusFlags": [
                  "finalized",
                  "need_corrections"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,500",
            "jobberPrice": "$1,200",
            "dealerPrice": "$1,050",
            "coreRequired": "Core or +$50",
            "processorArch": "Brainboard STM32",
            "channels": "PNP 2AR-FE / Dual VVT / ETB Jumpers / Cam Ground Fix",
            "description": "Computadora PNP para Scion TC 2 (4 back panels)",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/scion_tc2.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/2ar_tc2_base.bin",
            "stockQty": "20",
            "casesQty": "4"
      },
      {
            "id": "PROD-TOY-2GR",
            "name": "Toyota 2GR Avalon/Xrunner",
            "category": "plugin",
            "make": "Toyota",
            "model": "Avalon / Camry / Tacoma / X-Runner 1GR/2GR 3.5L V6",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,500",
            "jobberPrice": "$1,200",
            "dealerPrice": "$1,050",
            "coreRequired": "1",
            "processorArch": "Brainboard STM32",
            "channels": "Dual DBW / Quad VVT / V6 Sequential",
            "description": "PNP para varias aplicaciones de Toyota1/2GR",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/toyota_2gr.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/2gr_base.bin",
            "stockQty": "17",
            "casesQty": "1"
      },
      {
            "id": "PROD-VW-MK3VR6",
            "name": "VW Jetta/Golf MK3",
            "category": "plugin",
            "make": "VW",
            "model": "Golf / Jetta MK3 2.0L ABA / 2.8L VR6 12V",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "deprecated",
            "msrp": "$800",
            "jobberPrice": "$640",
            "dealerPrice": "$560",
            "coreRequired": "No",
            "processorArch": "Brainboard STM32",
            "channels": "60-2 VR Trigger / Wasted Spark / Idle ISV",
            "description": "Computadora PNP para VW Jetta/Golf MK3 2.0/VR6",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/vw_mk3.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/vr6_mk3_base.bin",
            "stockQty": "1",
            "casesQty": "0"
      },
      {
            "id": "PROD-VW-MK418T",
            "name": "VW Jetta/Golf MK4 1.8T",
            "category": "plugin",
            "make": "VW",
            "model": "Golf / Jetta MK4 1.8T 20V ME7.5 Plug",
            "currentRevision": "Rev 1.2",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,500",
            "jobberPrice": "$1,200",
            "dealerPrice": "$1,050",
            "coreRequired": "3",
            "processorArch": "Brainboard STM32",
            "channels": "60-2 VR Trigger / DBW / VVT Vane Control / N75 Boost",
            "description": "Computadora PNP para VW Jetta/Golf MK4 1.8T 20V",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/vw_mk4_18t.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/18t_mk4_base.bin",
            "stockQty": "5",
            "casesQty": "3"
      },
      {
            "id": "PROD-YAM-YXZ1000",
            "name": "Yamaha YXZ (1000R UTV)",
            "category": "plugin",
            "make": "Yamaha",
            "model": "Yamaha YXZ 1000R 3-Cylinder UTV 2016-2023",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$1,500",
            "jobberPrice": "$1,200",
            "dealerPrice": "$1,050",
            "coreRequired": "No",
            "processorArch": "Brainboard STM32",
            "channels": "3-Cylinder Sequential / DBW / Launch Control / Dash CAN",
            "description": "Computadora Standalone PNP para Yamaha YXZ 1000R",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/yamaha_yxz.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/yxz1000_base.bin",
            "stockQty": "2",
            "casesQty": "0"
      },
      {
            "id": "PROD-CHUMA-200EFI",
            "name": "Chuma 200EFI",
            "category": "plugin",
            "make": "Chuma EFI",
            "model": "Chuma EFI Small Engine / GY6 / Scooter",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$500",
            "jobberPrice": "$400",
            "dealerPrice": "$350",
            "coreRequired": "No",
            "processorArch": "Micro STM32 Core",
            "channels": "Single / Twin Cylinder EFI & Ignition",
            "description": "Computadora Plug and play de Chuma EFI",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/chuma_200efi.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/chuma_base.bin",
            "stockQty": "5",
            "casesQty": "1"
      },
      {
            "id": "PROD-CHUMA-MINI",
            "name": "Chuma 200EFI Mini",
            "category": "plugin",
            "make": "Chuma EFI",
            "model": "Chuma EFI Ultra-Compact Single Plug",
            "currentRevision": "Rev 1.1",
            "statusFlags": [
                  "finalized",
                  "need_corrections"
            ],
            "lifecycleStatus": "active",
            "msrp": "$300",
            "jobberPrice": "$240",
            "dealerPrice": "$210",
            "coreRequired": "30",
            "processorArch": "Micro STM32 Core",
            "channels": "Ultra-compact single cylinder fuel/spark",
            "description": "Computadora Plug and play de Chuma EFI (40 ordenadas)",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/chuma_mini.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/chuma_mini_base.bin",
            "stockQty": "40",
            "casesQty": "1"
      },
      {
            "id": "PROD-CHUMA-FARRUKO",
            "name": "Chuma Farruko V1",
            "category": "plugin",
            "make": "Chuma EFI",
            "model": "Chuma Farruko Racing Edition",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$500",
            "jobberPrice": "$400",
            "dealerPrice": "$350",
            "coreRequired": "No",
            "processorArch": "Micro STM32 Core",
            "channels": "High RPM single/twin racing ignition and fuel",
            "description": "Computadora Chuma Farruko V1 para carreras",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/chuma_farruko.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/chuma_farruko_base.bin",
            "stockQty": "4",
            "casesQty": "0"
      },
      {
            "id": "PROD-CHUMA-MAXUMA",
            "name": "Chuma Maxuma/Itallica/Tank/Supermach",
            "category": "plugin",
            "make": "Chuma EFI",
            "model": "Scooter / Motorcycle Maxuma / Italika / Tank",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$350",
            "jobberPrice": "$280",
            "dealerPrice": "$245",
            "coreRequired": "No",
            "processorArch": "Micro STM32 Core",
            "channels": "Plug and play para marcas chinas Maxuma, Italika, Tank y Supermach",
            "description": "Computadora Plug and Play para motos Chuma/Italika",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/chuma_maxuma.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/chuma_maxuma_base.bin",
            "stockQty": "10",
            "casesQty": "0"
      },
      {
            "id": "PROD-CHUMA-2PLUG",
            "name": "Chuma 2 Plug V1",
            "category": "plugin",
            "make": "Chuma EFI",
            "model": "Chuma Dual Plug Harness EFI",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "finalized",
                  "need_corrections"
            ],
            "lifecycleStatus": "active",
            "msrp": "$450",
            "jobberPrice": "$360",
            "dealerPrice": "$315",
            "coreRequired": "No",
            "processorArch": "Micro STM32 Core",
            "channels": "Dual Plug architecture for expanded I/O",
            "description": "Computadora Chuma EFI versi\u00f3n de 2 plugs",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/chuma_2plug.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/chuma_2plug_base.bin",
            "stockQty": "10",
            "casesQty": "2"
      },
      {
            "id": "PROD-PROTO-ECONOLINE",
            "name": "ProtoRico Econoline / Econolive V3",
            "category": "protorico",
            "make": "ProtoRico",
            "model": "Econoline Modular Multi-Engine V3",
            "currentRevision": "Rev 3.0",
            "statusFlags": [
                  "finalized",
                  "need_corrections"
            ],
            "lifecycleStatus": "active",
            "msrp": "$650",
            "jobberPrice": "$520",
            "dealerPrice": "$455",
            "coreRequired": "No",
            "processorArch": "Modular STM32 Carrier",
            "channels": "Dual VR Conditioner / Configurable Output Transistors",
            "description": "Plataforma de desarrollo ProtoRico Econoline modular V3",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/protorico_econoline.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/protorico_base.bin",
            "stockQty": "2",
            "casesQty": "0"
      },
      {
            "id": "PROD-PROTO-GRUMMAN",
            "name": "ProtoRico Grumman V1",
            "category": "protorico",
            "make": "ProtoRico",
            "model": "Grumman Industrial / Fleet Engine",
            "currentRevision": "Rev 1.0",
            "statusFlags": [
                  "testing_validation"
            ],
            "lifecycleStatus": "active",
            "msrp": "$750",
            "jobberPrice": "$600",
            "dealerPrice": "$525",
            "coreRequired": "No",
            "processorArch": "Modular STM32 Carrier",
            "channels": "Heavy Duty Fleet Vehicle I/O",
            "description": "Plataforma de control ECU industrial ProtoRico Grumman V1",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/protorico_grumman.pdf",
            "baseTuneUrl": "https://cdn.alphax.com/tunes/grumman_base.bin",
            "stockQty": "2",
            "casesQty": "0"
      },
      {
            "id": "PROD-ACC-VRCOND",
            "name": "AlphaECU VR Conditioner -Neo",
            "category": "accessory",
            "make": "Universal",
            "model": "VR to Digital Hall Converter (1-Channel)",
            "currentRevision": "Rev 2.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$49",
            "jobberPrice": "$40",
            "dealerPrice": "$35",
            "coreRequired": "N/A",
            "processorArch": "MAX9926 High Precision Adaptive VR Chip",
            "channels": "1-Channel differential VR to 5V Hall converter",
            "description": "Convertidor de VR a Hall un canal",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/vr_conditioner.pdf",
            "baseTuneUrl": "",
            "stockQty": "113",
            "casesQty": "N/A"
      },
      {
            "id": "PROD-ACC-IGN1CH",
            "name": "AlphaECU Igniter -Neo --1chan",
            "category": "accessory",
            "make": "Universal",
            "model": "1-Channel Dumb Coil Igniter Driver",
            "currentRevision": "Rev 1.2",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$40",
            "jobberPrice": "$30",
            "dealerPrice": "$28",
            "coreRequired": "N/A",
            "processorArch": "IGBT 20A Ignition Driver",
            "channels": "1-Channel high energy coil driver",
            "description": "Igniter de 1 canal, para poder usar bobinas 'dumb'",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/igniter_1ch.pdf",
            "baseTuneUrl": "",
            "stockQty": "20+",
            "casesQty": "N/A"
      },
      {
            "id": "PROD-ACC-IGN4CH",
            "name": "AlphaECU Igniter -Neo --4chan",
            "category": "accessory",
            "make": "Universal",
            "model": "4-Channel Dumb Coil Igniter Driver",
            "currentRevision": "Rev 1.3",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$80",
            "jobberPrice": "$64",
            "dealerPrice": "$60",
            "coreRequired": "14",
            "processorArch": "Quad IGBT 20A Ignition Module",
            "channels": "4-Channel high energy coil driver module with heatsink case",
            "description": "Igniter de 4 canales, para poder usar bobinas 'dumb'",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/igniter_4ch.pdf",
            "baseTuneUrl": "",
            "stockQty": "40+",
            "casesQty": "14"
      },
      {
            "id": "PROD-ACC-IGN8CH",
            "name": "AlphaECU Igniter -Neo --8chan",
            "category": "accessory",
            "make": "Universal",
            "model": "8-Channel Dumb Coil Igniter Driver (V8)",
            "currentRevision": "Rev 1.1",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$120",
            "jobberPrice": "$100",
            "dealerPrice": "$80",
            "coreRequired": "5",
            "processorArch": "Octal IGBT 20A Ignition Module",
            "channels": "8-Channel high energy coil driver module for V8 engines",
            "description": "Igniter de 8 canales, para poder usar bobinas 'dumb'",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/igniter_8ch.pdf",
            "baseTuneUrl": "",
            "stockQty": "5",
            "casesQty": "5"
      },
      {
            "id": "PROD-ACC-WEYBAN",
            "name": "AlphaX Wideband WBO2 -Weyban",
            "category": "accessory",
            "make": "Universal",
            "model": "Bosch LSU 4.9 Controller Module",
            "currentRevision": "Rev 1.4",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$80",
            "jobberPrice": "$60",
            "dealerPrice": "$60",
            "coreRequired": "6",
            "processorArch": "Bosch CJ125 / LSU 4.9 Precision Controller",
            "channels": "Analog 0-5V Linear AFR Output + CANBUS Digital Stream",
            "description": "Modulo para usar widebands con un sensor Bosch LSU 4.9",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/weyban_wideband.pdf",
            "baseTuneUrl": "",
            "stockQty": "33",
            "casesQty": "6"
      },
      {
            "id": "PROD-ACC-RELAYPANEL",
            "name": "AlphaX Relay Panel (RelayPenal)",
            "category": "accessory",
            "make": "Universal",
            "model": "Dual 70A + Quad 20A Power Distribution",
            "currentRevision": "Rev 2.0",
            "statusFlags": [
                  "finalized"
            ],
            "lifecycleStatus": "active",
            "msrp": "$69",
            "jobberPrice": "$55",
            "dealerPrice": "$50",
            "coreRequired": "N/A",
            "processorArch": "Heavy-Duty Automotive Relay Board",
            "channels": "2x 70A Relays + 4x 20A Relays + Fuse Block",
            "description": "Panel de Relays, con dos relays de 70A, y 4 relays de 20a, ademas de fusibles y main relay",
            "pinoutUrl": "https://cdn.alphax.com/pinouts/relay_panel.pdf",
            "baseTuneUrl": "",
            "stockQty": "25",
            "casesQty": "N/A"
      }
],

    revisions: [
      {
            "id": "REV-8THGEN-1.0",
            "productId": "PROD-HON-8THGEN",
            "revisionNumber": "Rev 1.0",
            "releaseDate": "2026-01-15T09:00:00Z",
            "bumpedBy": "Norman Paulino",
            "changelog": "Initial 8th Gen Civic Si K20Z3 PNP prototype board.",
            "statusAtRevision": "need_corrections",
            "reworkInstructions": "Requires manual ETB horizontal jumpers and 1K 12V pullup to EPS_RPM pin.",
            "isCurrent": false
      },
      {
            "id": "REV-8THGEN-1.1",
            "productId": "PROD-HON-8THGEN",
            "revisionNumber": "Rev 1.1",
            "releaseDate": "2026-05-10T14:00:00Z",
            "bumpedBy": "Norman Paulino",
            "changelog": "Production batch 2. Maintained ETB solder jumpers. Bench verification required.",
            "statusAtRevision": "finalized",
            "reworkInstructions": "1. Solder ETB Jumpers HORIZONTALLY (SCS to NOS Output).\n2. Solder 1K 12V pullup to EPS_RPM.",
            "isCurrent": true
      },
      {
            "id": "REV-SERIEB-1.4",
            "productId": "PROD-HON-SERIEB",
            "revisionNumber": "Rev 1.4",
            "releaseDate": "2026-04-18T16:00:00Z",
            "bumpedBy": "Norman Paulino",
            "changelog": "P28 PNP updated batch. Standardized jumper paths.",
            "statusAtRevision": "finalized",
            "reworkInstructions": "1. Remove ALL components from Hall circuit area.\n2. Jump green trace pads for OEM trigger.",
            "isCurrent": true
      },
      {
            "id": "REV-TOY2ZZ-1.5",
            "productId": "PROD-TOY-2ZZ0506",
            "revisionNumber": "Rev 1.5",
            "releaseDate": "2026-06-02T13:00:00Z",
            "bumpedBy": "Norman Paulino",
            "changelog": "Resolved lift driver layout. Added jumper alignment check.",
            "statusAtRevision": "finalized",
            "reworkInstructions": "Bench verify Lift output circuit before sealing case.",
            "isCurrent": true
      },
      {
            "id": "REV-SCIONTC2-1.2",
            "productId": "PROD-SCION-TC2",
            "revisionNumber": "Rev 1.2",
            "releaseDate": "2026-06-15T15:30:00Z",
            "bumpedBy": "Norman Paulino",
            "changelog": "Added CAM sensor ground solder jumper and horizontal ETB jumpers.",
            "statusAtRevision": "finalized",
            "reworkInstructions": "1. Solder ETB Jumpers HORIZONTALLY.\n2. Solder CAM Sensor Ground wire to ground header.",
            "isCurrent": true
      },
      {
            "id": "REV-S197-REVA",
            "productId": "PROD-FORD-S197COYOTE",
            "revisionNumber": "Rev A",
            "releaseDate": "2026-02-10T10:00:00Z",
            "bumpedBy": "Norman Paulino",
            "changelog": "First prototype run of S197 Coyote 5.0 board.",
            "statusAtRevision": "need_corrections",
            "reworkInstructions": "3.3V area unrouted. Solder bridge wire from 5V PSU to 3.3V LDO input.",
            "isCurrent": true
      },
      {
            "id": "REV-S550-V2",
            "productId": "PROD-FORD-S550",
            "revisionNumber": "Rev 2.0",
            "releaseDate": "2026-07-20T12:00:00Z",
            "bumpedBy": "Norman Paulino",
            "changelog": "S550 V2 production board. Corrected diode silk and trace orientation.",
            "statusAtRevision": "finalized",
            "reworkInstructions": "V2 boards are clean. Check diode D2 on legacy V1 stock.",
            "isCurrent": true
      },
      {
            "id": "REV-ECLIPSE-1.2",
            "productId": "PROD-MITS-ECLIPSE6G75",
            "revisionNumber": "Rev 1.2",
            "releaseDate": "2026-04-10T11:00:00Z",
            "bumpedBy": "Norman Paulino",
            "changelog": "Eclipse 06+ 6G75 batch. Solder 2x 1K parallel pullup resistors.",
            "statusAtRevision": "finalized",
            "reworkInstructions": "Solder two 1k resistors in parallel between signal tab and VCC (5V).",
            "isCurrent": true
      },
      {
            "id": "REV-SKYLINE-1.1",
            "productId": "PROD-NIS-SKYLINE",
            "revisionNumber": "Rev 1.1",
            "releaseDate": "2026-05-15T14:00:00Z",
            "bumpedBy": "Norman Paulino",
            "changelog": "Skyline R32/33/34 RB20/25/26 production revision.",
            "statusAtRevision": "finalized",
            "reworkInstructions": "CAS trigger filtering verified. Ready for bench test.",
            "isCurrent": true
      }
],

    fixes: [
      {
            "id": "FIX-8THGEN-01",
            "productId": "PROD-HON-8THGEN",
            "applicableRevision": "Rev 1.1",
            "title": "ETB Horizontal Jumpers",
            "instructions": "Solder ETB jumpers HORIZONTALLY to route SCS (Service Check Signal) directly to NOS Output.",
            "category": "jumper",
            "isMandatory": true,
            "guideDoc": "8th gen.docx",
            "images": [
                  "8th_gen_image1.png",
                  "8th_gen_10000001000001A20000011F7B94B21B.png"
            ],
            "createdAt": "2026-08-01T10:00:00Z"
      },
      {
            "id": "FIX-8THGEN-02",
            "productId": "PROD-HON-8THGEN",
            "applicableRevision": "Rev 1.1",
            "title": "EPS_RPM 12V 1K Pullup Resistor",
            "instructions": "Solder a 1K ohm 1/4W resistor from 12V rail to EPS_RPM header pin to ensure electric power steering controller reads engine tachometer correctly.",
            "category": "pullup_pulldown",
            "isMandatory": true,
            "guideDoc": "8th gen.docx",
            "images": [
                  "8th_gen_image1.png"
            ],
            "createdAt": "2026-08-01T10:00:00Z"
      },
      {
            "id": "FIX-SERIEB-01",
            "productId": "PROD-HON-SERIEB",
            "applicableRevision": "Rev 1.4",
            "title": "Remove Hall Area Components",
            "instructions": "Remove ALL SMD components from the Hall conditioning section when unit is built for OEM Honda Optical/VR distributor.",
            "category": "component_swap",
            "isMandatory": true,
            "guideDoc": "serieB pnp fixes.docx",
            "images": [
                  "serieb_pnp_fixes_image1.png",
                  "serieb_pnp_fixes_image2.png"
            ],
            "createdAt": "2026-08-01T10:00:00Z"
      },
      {
            "id": "FIX-SERIEB-02",
            "productId": "PROD-HON-SERIEB",
            "applicableRevision": "Rev 1.4",
            "title": "OEM Trigger Green Line Jumpers",
            "instructions": "If using OEM distributor trigger: Solder jumper across all designated green trace pads.",
            "category": "jumper",
            "isMandatory": true,
            "guideDoc": "serieB pnp fixes.docx",
            "images": [
                  "serieb_pnp_fixes_image3.png"
            ],
            "createdAt": "2026-08-01T10:00:00Z"
      },
      {
            "id": "FIX-ECLIPSE-01",
            "productId": "PROD-MITS-ECLIPSE6G75",
            "applicableRevision": "Rev 1.2",
            "title": "Dual 1K Parallel Resistors on VCC",
            "instructions": "Poner dos resistores de 1k en paralelo entre la leng\u00fceta de se\u00f1al y la l\u00ednea principal VCC (5V).",
            "category": "pullup_pulldown",
            "isMandatory": true,
            "guideDoc": "Eclipse 3.8 fix.docx",
            "images": [
                  "eclipse_3.8_fix_image1.png"
            ],
            "createdAt": "2026-08-01T10:00:00Z"
      },
      {
            "id": "FIX-SCIONTC1-01",
            "productId": "PROD-SCION-TC0811",
            "applicableRevision": "Rev 1.5",
            "title": "TC 1.5 ETB Jumpers & AC Pullup",
            "instructions": "Solder TC 1.5 ETB Jumpers horizontally for AC Request line with 5V pullup resistor.",
            "category": "jumper",
            "isMandatory": true,
            "guideDoc": "TC 1.5.odt",
            "images": [
                  "tc_1.5_1000000100000237000001C3060FB55D.png",
                  "tc_1.5_1000000100000128000000C04FA567AF.png"
            ],
            "createdAt": "2026-08-01T10:00:00Z"
      },
      {
            "id": "FIX-SCIONTC2-01",
            "productId": "PROD-SCION-TC2",
            "applicableRevision": "Rev 1.2",
            "title": "TC2 Horizontal ETB Jumpers & CAM Ground",
            "instructions": "1. Solder ETB Jumpers horizontally.\n2. Solder dedicated CAM sensor ground wire directly to ground plane.",
            "category": "jumper",
            "isMandatory": true,
            "guideDoc": "TC2 ETB Jumpers.odt",
            "images": [
                  "tc2_etb_jumpers_100000010000018D000001A94C44A555.png",
                  "tc2_etb_jumpers_100000010000016D59D00791.png"
            ],
            "createdAt": "2026-08-01T10:00:00Z"
      },
      {
            "id": "FIX-S550-01",
            "productId": "PROD-FORD-S550",
            "applicableRevision": "Rev 1.0",
            "title": "S550 Diode Orientation & Relay Install",
            "instructions": "Poner relay (en la foto aparece como diodo). Cambiar orientaci\u00f3n de este diodo D2 y remover diodos quemados si se aliment\u00f3 invertido en pruebas.",
            "category": "component_swap",
            "isMandatory": true,
            "guideDoc": "S550 fixes.docx",
            "images": [
                  "s550_fixes_image1.png",
                  "s550_fixes_image2.png",
                  "s550_fixes_image3.png",
                  "s550_fixes_image4.png"
            ],
            "createdAt": "2026-08-01T10:00:00Z"
      },
      {
            "id": "FIX-S197-01",
            "productId": "PROD-FORD-S197COYOTE",
            "applicableRevision": "Rev A",
            "title": "S197 Coyote 3.3V Net Bridge",
            "instructions": "revA 3.3V area is completely unrouted on main net. Solder bridge wire from 5V PSU area to 3.3V LDO input. This supplies reliable 3.3V to main net, enables USB powerup, and powers analog 3.3V sensors.",
            "category": "trace_cut",
            "isMandatory": true,
            "guideDoc": "S197 Coyote.docx",
            "images": [
                  "s197_coyote_image1.png",
                  "s197_coyote_image2.png",
                  "s197_coyote_image3.png"
            ],
            "createdAt": "2026-08-01T10:00:00Z"
      },
      {
            "id": "FIX-CHUMAMICRO-01",
            "productId": "PROD-CHUMA-MINI",
            "applicableRevision": "Rev 1.0",
            "title": "Chuma Bootloader Fideo Jumper",
            "instructions": "Solder thin jumper wire (fideo) to boot pin in order to upload initial firmware via ST-Link programmer.",
            "category": "firmware",
            "isMandatory": true,
            "guideDoc": "Chuma Micro.odt",
            "images": [
                  "chuma_micro_1000000100000198000001F880259F62.png"
            ],
            "createdAt": "2026-08-01T10:00:00Z"
      },
      {
            "id": "FIX-RALLIART-01",
            "productId": "PROD-MITS-RALLIART",
            "applicableRevision": "Rev 1.1",
            "title": "Ralliart Pin 54 to 69 Jumper",
            "instructions": "Jump pin 54 to pin 69 (b24 to c9) on back panel. Set pull resistor on MIVEC trigger line to pulldown configuration.",
            "category": "jumper",
            "isMandatory": true,
            "guideDoc": "ralliart.docx",
            "images": [
                  "ralliart_image1.png"
            ],
            "createdAt": "2026-08-01T10:00:00Z"
      },
      {
            "id": "FIX-PROTOECONO-01",
            "productId": "PROD-PROTO-ECONOLINE",
            "applicableRevision": "Rev 3.0",
            "title": "Econoline VR & Output Transistor Rework",
            "instructions": "1. Jump second-to-last pad to transistor drive circuit.\n2. Wire VR1/2+ to the bottom pins, remove two 10K filter resistors.\n3. VR1/2- go to sensor ground.\n4. Remove 9926 and top two resistors if using discrete input.",
            "category": "trace_cut",
            "isMandatory": true,
            "guideDoc": "ProtoRico Econoline modular.docx",
            "images": [
                  "protorico_econoline_modular_image1.png",
                  "protorico_econoline_modular_image2.png"
            ],
            "createdAt": "2026-08-01T10:00:00Z"
      }
],

    tasks: [
      {
            "id": "TASK-8THGEN-01",
            "productId": "PROD-HON-8THGEN",
            "title": "Integrate 12V EPS Pullup on PCB",
            "description": "Route 1K 12V pullup resistor directly on next PCB revision to eliminate manual bench soldering for EPS_RPM.",
            "priority": "high",
            "status": "resolved_in_next_rev",
            "targetRevision": "Rev 2.0",
            "assignedTo": "Norman Paulino",
            "createdAt": "2026-08-05T10:00:00Z",
            "updatedAt": "2026-08-12T14:00:00Z"
      },
      {
            "id": "TASK-S197-01",
            "productId": "PROD-FORD-S197COYOTE",
            "title": "Route 3.3V Power Plane in Rev B",
            "description": "Re-route 3.3V power traces from 5V buck converter to 3.3V LDO to resolve Rev A unrouted net defect.",
            "priority": "critical",
            "status": "in_progress",
            "targetRevision": "Rev B",
            "assignedTo": "Norman Paulino",
            "createdAt": "2026-08-06T11:00:00Z",
            "updatedAt": "2026-08-11T16:00:00Z"
      },
      {
            "id": "TASK-TC2-01",
            "productId": "PROD-SCION-TC2",
            "title": "Hardwire CAM Ground Plane on PCB Rev 2.0",
            "description": "Add dedicated solid copper ground pour for Cam Position Sensor connector pins to remove manual flywire.",
            "priority": "medium",
            "status": "backlog",
            "targetRevision": "Rev 2.0",
            "assignedTo": "Norman Paulino",
            "createdAt": "2026-08-08T15:00:00Z",
            "updatedAt": "2026-08-08T15:00:00Z"
      }
],

    notes: [
      { id: "NOTE-8THGEN-01", productId: "PROD-HON-8THGEN", revisionNumber: "Rev 1.1", author: "Norman Paulino", text: "Bench tested batch of 5 units on JimStim + CANBUS cluster simulator. Tachometer sweep, VTEC solenoid output, and EPS RPM signal confirmed 100% stable at 8500 RPM.", category: "bench_testing", images: ["8th_gen_image1.png"], timestamp: "2026-08-10T16:40:00Z" },
      { id: "NOTE-8THGEN-02", productId: "PROD-HON-8THGEN", revisionNumber: "Rev 1.1", author: "Raymond Ortiz", text: "QC completed on 3 units for RAG Custom Wire order. 1K pullup verified with multimeter.", category: "assembly_qc", images: [], timestamp: "2026-08-12T11:20:00Z" },
      { id: "NOTE-S550-01", productId: "PROD-FORD-S550", revisionNumber: "Rev 2.0", author: "Norman Paulino", text: "S550 V2 boards arrived from fab. Diode orientation is correct on new batch. Legacy V1 boards in blue bin still need manual relay modification.", category: "hardware_design", images: ["s550_fixes_image1.png"], timestamp: "2026-08-11T15:00:00Z" }
    ]
  };

  // State
  let state = {
    currentUser: null,
    products: [],
    revisions: [],
    fixes: [],
    tasks: [],
    notes: [],
    selectedProduct: null,
    activeCategory: 'all',
    filterCorrectionsOnly: false,
    filterEngRevOnly: false,
    showObsolete: false,
    viewingRevision: "all",
    searchQuery: '',
    viewMode: 'matrix' // 'matrix' | 'workspace'
  };

  // Attached images for new note creation
  let pendingNoteImages = [];
  let activeNoteCategoryFilter = 'all';
  let targetNoteForImageUpdate = null;

  // DOM Elements cache
  let el = {};

  // Initialize
  document.addEventListener('DOMContentLoaded', initApp);

  function initApp() {
    Logger.log('🚀 Initializing AlphaX ECU Design Tracker Portal...');
    if (APPS_SCRIPT_URL && !APPS_SCRIPT_URL.includes('YOUR_DEPLOYED_APPS_SCRIPT')) {
      Logger.api('🌐 Live Backend URL:', APPS_SCRIPT_URL);
    } else {
      Logger.api('⚡ Running in Offline / Local Mode (Zero-latency LocalStorage & Seed Data active)');
    }
    cacheElements();
    bindEvents();
    loadLocalData();
    checkAuthSession();
    fetchRemoteData();
  }

  function cacheElements() {
    el.app = document.getElementById('alphax-design-app');
    el.toastContainer = document.getElementById('alphax-toast-container');
    el.loginModal = document.getElementById('login-modal-backdrop');
    el.formLogin = document.getElementById('form-staff-login');
    el.loginError = document.getElementById('login-error-msg');
    
    el.currentUserAvatar = document.getElementById('current-user-avatar');
    el.currentUserName = document.getElementById('current-user-name');
    el.currentUserRole = document.getElementById('current-user-role');
    el.btnStaffLogout = document.getElementById('btn-staff-logout');
    el.btnOpenChangePassword = document.getElementById('btn-open-change-password');
    el.changePasswordModal = document.getElementById('change-password-modal-backdrop');
    el.formChangePassword = document.getElementById('form-change-password');
    el.btnCloseChangePassword = document.getElementById('btn-close-change-password');
    el.btnCancelChangePassword = document.getElementById('btn-cancel-change-password');

    // Stats
    el.statTotal = document.getElementById('stat-total-products');
    el.statFinalized = document.getElementById('stat-finalized');
    el.statCorrections = document.getElementById('stat-corrections');
    el.statEngRev = document.getElementById('stat-eng-rev');
    el.statTesting = document.getElementById('stat-testing');

    // Cascading Dropdowns
    el.selectCategory = document.getElementById('select-category');
    el.selectMake = document.getElementById('select-make');
    el.selectModel = document.getElementById('select-model');
    el.selectRevision = document.getElementById('select-revision');
    el.stepMakeWrap = document.getElementById('step-make-wrap');
    el.stepModelWrap = document.getElementById('step-model-wrap');
    el.stepRevisionWrap = document.getElementById('step-revision-wrap');
    el.crumbCategory = document.getElementById('crumb-category');
    el.crumbMake = document.getElementById('crumb-make');
    el.crumbModel = document.getElementById('crumb-model');
    el.crumbSepMake = document.getElementById('crumb-sep-make');
    el.crumbSepModel = document.getElementById('crumb-sep-model');
    el.btnResetPicker = document.getElementById('btn-reset-picker');
    el.btnViewMatrix = document.getElementById('btn-view-matrix');
    el.totalProductCount = document.getElementById('total-product-count');
    el.selectorQuickSearch = document.getElementById('selector-quick-search');
    el.btnClearSearch = document.getElementById('btn-clear-search');

    // Views
    el.viewMatrix = document.getElementById('view-matrix');
    el.viewWorkspace = document.getElementById('view-product-workspace');
    el.matrixTableBody = document.getElementById('matrix-table-body');
    el.filterTabs = document.querySelectorAll('.filter-tab');
    el.chkFilterCorrections = document.getElementById('chk-filter-corrections');
    el.chkFilterEngRev = document.getElementById('chk-filter-eng-rev');
    el.chkShowObsolete = document.getElementById('chk-show-obsolete');
    el.wpProductLifecycle = document.getElementById('wp-product-lifecycle');
    el.crudLifecycle = document.getElementById('crud-lifecycle');

    // Counts on filter tabs
    el.countAll = document.getElementById('count-filter-all');
    el.countPlugin = document.getElementById('count-filter-plugin');
    el.countUniversal = document.getElementById('count-filter-universal');
    el.countAccessory = document.getElementById('count-filter-accessory');
    el.countProtorico = document.getElementById('count-filter-protorico');

    // Product Workspace Elements
    el.wpCategory = document.getElementById('wp-product-category');
    el.wpName = document.getElementById('wp-product-name');
    el.wpModelSpec = document.getElementById('wp-product-model-spec');
    el.wpRevisionNumber = document.getElementById('wp-revision-number');
    el.wpRevisionStatus = document.getElementById('wp-revision-status');
    el.wpViewingRevisionSelect = document.getElementById('wp-viewing-revision-select');
    el.wpMsrp = document.getElementById('wp-msrp');
    el.wpDealerPrice = document.getElementById('wp-dealer-price');
    el.wpStock = document.getElementById('wp-stock');
    el.wpCases = document.getElementById('wp-cases');
    el.wpSpecMcu = document.getElementById('wp-spec-mcu');
    el.wpSpecChannels = document.getElementById('wp-spec-channels');
    el.wpSpecCore = document.getElementById('wp-spec-core');
    el.wpSpecJobber = document.getElementById('wp-spec-jobber');
    el.wpSpecDesc = document.getElementById('wp-spec-desc');
    el.wpLinkPinout = document.getElementById('wp-link-pinout');
    el.wpLinkTune = document.getElementById('wp-link-tune');

    el.flagFinalized = document.getElementById('flag-finalized');
    el.flagCorrections = document.getElementById('flag-corrections');
    el.flagEngRev = document.getElementById('flag-eng-rev');
    el.flagTesting = document.getElementById('flag-testing');

    el.wpFixesList = document.getElementById('wp-fixes-list');
    el.wpFixesCount = document.getElementById('wp-fixes-count');
    el.wpRevisionTimeline = document.getElementById('wp-revision-timeline');
    el.wpTasksList = document.getElementById('wp-tasks-list');
    el.wpTasksCount = document.getElementById('wp-tasks-count');
    el.wpNotesThread = document.getElementById('wp-notes-thread');

    // Modals
    el.modalBumpRevision = document.getElementById('modal-bump-revision');
    el.formBumpRevision = document.getElementById('form-bump-revision');
    el.bumpProductId = document.getElementById('bump-product-id');
    el.bumpProductNameDisplay = document.getElementById('bump-product-name-display');
    el.bumpCurrentRevDisplay = document.getElementById('bump-current-rev-display');
    el.bumpNewRevision = document.getElementById('bump-new-revision');
    el.bumpChangelog = document.getElementById('bump-changelog');
    el.bumpFixesChecklist = document.getElementById('bump-fixes-checklist');
    el.bumpRemainingRework = document.getElementById('bump-remaining-rework');
    el.btnOpenBumpRevision = document.getElementById('btn-open-bump-revision');
    el.btnCloseBumpRevision = document.getElementById('btn-close-bump-revision');
    el.btnCancelBumpRevision = document.getElementById('btn-cancel-bump-revision');

    el.modalProductCrud = document.getElementById('modal-product-crud');
    el.formProductCrud = document.getElementById('form-product-crud');
    el.modalProductTitle = document.getElementById('modal-product-title');
    el.crudProductId = document.getElementById('crud-product-id');
    el.crudCategory = document.getElementById('crud-category');
    el.crudMake = document.getElementById('crud-make');
    el.crudName = document.getElementById('crud-name');
    el.crudModel = document.getElementById('crud-model');
    el.crudRevision = document.getElementById('crud-revision');
    el.crudMcu = document.getElementById('crud-mcu');
    el.crudChannels = document.getElementById('crud-channels');
    el.crudMsrp = document.getElementById('crud-msrp');
    el.crudDealer = document.getElementById('crud-dealer');
    el.crudCore = document.getElementById('crud-core');
    el.crudDesc = document.getElementById('crud-desc');
    el.crudPinoutUrl = document.getElementById('crud-pinout-url');
    el.crudTuneUrl = document.getElementById('crud-tune-url');
    el.btnDeleteProduct = document.getElementById('btn-delete-product');
    el.btnOpenNewProduct = document.getElementById('btn-open-new-product');
    el.btnEditCurrentProduct = document.getElementById('btn-edit-current-product');
    el.btnCloseProductCrud = document.getElementById('btn-close-product-crud');
    el.btnCancelProductCrud = document.getElementById('btn-cancel-product-crud');

    el.modalFixGuide = document.getElementById('modal-fix-guide');
    el.guideModalTitle = document.getElementById('guide-modal-title');
    el.guideMetaProduct = document.getElementById('guide-meta-product');
    el.guideMetaRevision = document.getElementById('guide-meta-revision');
    el.guideMetaCategory = document.getElementById('guide-meta-category');
    el.guideInstructionsText = document.getElementById('guide-instructions-text');
    el.guideImageGallery = document.getElementById('guide-image-gallery');
    el.btnCloseFixGuide = document.getElementById('btn-close-fix-guide');
    el.btnCloseGuideFooter = document.getElementById('btn-close-guide-footer');

    el.modalAddFix = document.getElementById('modal-add-fix');
    el.formAddFix = document.getElementById('form-add-fix');
    el.addfixProductId = document.getElementById('addfix-product-id');
    el.addfixCategory = document.getElementById('addfix-category');
    el.addfixApplicableRev = document.getElementById('addfix-applicable-rev');
    el.addfixTitle = document.getElementById('addfix-title');
    el.addfixInstructions = document.getElementById('addfix-instructions');
    el.addfixIsMandatory = document.getElementById('addfix-is-mandatory');
    el.btnOpenAddFix = document.getElementById('btn-open-add-fix');
    el.btnCloseAddFix = document.getElementById('btn-close-add-fix');
    el.btnCancelAddFix = document.getElementById('btn-cancel-add-fix');

    el.modalAddTask = document.getElementById('modal-add-task');
    el.formAddTask = document.getElementById('form-add-task');
    el.addtaskId = document.getElementById('addtask-product-id');
    el.addtaskTitle = document.getElementById('addtask-title');
    el.addtaskPriority = document.getElementById('addtask-priority');
    el.addtaskTargetRev = document.getElementById('addtask-target-rev');
    el.addtaskAssigned = document.getElementById('addtask-assigned');
    el.addtaskStatus = document.getElementById('addtask-status');
    el.addtaskDesc = document.getElementById('addtask-desc');
    el.btnOpenAddTask = document.getElementById('btn-open-add-task');
    el.btnCloseAddTask = document.getElementById('btn-close-add-task');
    el.btnCancelAddTask = document.getElementById('btn-cancel-add-task');

    el.formAddNote = document.getElementById('form-add-note');
    el.inputNoteText = document.getElementById('input-note-text');
    el.selectNoteCategory = document.getElementById('select-note-category');
    el.inputNoteImages = document.getElementById('input-note-images');
    el.notePendingImages = document.getElementById('note-pending-images');
    el.noteImageCounter = document.getElementById('note-image-counter');
    el.inputUpdateNoteImages = document.getElementById('input-update-note-images');
    el.noteFilterBar = document.getElementById('note-filter-bar');

    el.modalImageLightbox = document.getElementById('modal-image-lightbox');
    el.lightboxImg = document.getElementById('lightbox-img');
    el.lightboxTitle = document.getElementById('lightbox-title');
    el.lightboxCaption = document.getElementById('lightbox-caption');
    el.btnCloseLightbox = document.getElementById('btn-close-lightbox');

    el.formQcBench = document.getElementById('form-qc-bench');
    el.qcSerialNumber = document.getElementById('qc-serial-number');
    el.qcBaseTune = document.getElementById('qc-base-tune');

    el.btnExportCatalog = document.getElementById('btn-export-catalog');
  }

  function bindEvents() {
    // Auth
    el.formLogin.addEventListener('submit', handleLoginSubmit);
    el.btnStaffLogout.addEventListener('click', handleLogout);
    el.btnOpenChangePassword.addEventListener('click', () => openModal(el.changePasswordModal));
    el.btnCloseChangePassword.addEventListener('click', () => closeModal(el.changePasswordModal));
    el.btnCancelChangePassword.addEventListener('click', () => closeModal(el.changePasswordModal));
    el.formChangePassword.addEventListener('submit', handleChangePasswordSubmit);

    // Cascading Selectors
    el.selectCategory.addEventListener('change', handleCategoryChange);
    el.selectMake.addEventListener('change', handleMakeChange);
    el.selectModel.addEventListener('change', handleModelChange);
    el.selectRevision.addEventListener('change', handleRevisionChange);
    el.btnResetPicker.addEventListener('click', resetCascadingFilters);
    el.btnViewMatrix.addEventListener('click', showMatrixView);

    // Search
    el.selectorQuickSearch.addEventListener('input', handleQuickSearch);
    el.btnClearSearch.addEventListener('click', clearSearch);

    // Matrix Filters
    el.filterTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        el.filterTabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        state.activeCategory = tab.getAttribute('data-filter');
        renderMatrixTable();
      });
    });

    el.chkFilterCorrections.addEventListener('change', (e) => {
      state.filterCorrectionsOnly = e.target.checked;
      renderMatrixTable();
    });

    el.chkFilterEngRev.addEventListener('change', (e) => {
      state.filterEngRevOnly = e.target.checked;
      renderMatrixTable();
    });

    // Status Flags Toggles
    [el.flagFinalized, el.flagCorrections, el.flagEngRev, el.flagTesting].forEach(chk => {
      chk.addEventListener('change', handleStatusFlagsChange);
    });

    // Bump Revision Modal
    el.btnOpenBumpRevision.addEventListener('click', openBumpRevisionModal);
    el.btnCloseBumpRevision.addEventListener('click', () => closeModal(el.modalBumpRevision));
    el.btnCancelBumpRevision.addEventListener('click', () => closeModal(el.modalBumpRevision));
    el.formBumpRevision.addEventListener('submit', handleBumpRevisionSubmit);

    // Product CRUD Modal
    el.btnOpenNewProduct.addEventListener('click', () => openProductCrudModal(null));
    if (el.btnEditCurrentProduct) {
      el.btnEditCurrentProduct.addEventListener('click', () => openProductCrudModal(state.selectedProduct));
    }
    el.btnCloseProductCrud.addEventListener('click', () => closeModal(el.modalProductCrud));
    el.btnCancelProductCrud.addEventListener('click', () => closeModal(el.modalProductCrud));
    el.btnDeleteProduct.addEventListener('click', handleDeleteProductSubmit);
    el.formProductCrud.addEventListener('submit', handleProductCrudSubmit);

    // Fix Guide Modal
    el.btnCloseFixGuide.addEventListener('click', () => closeModal(el.modalFixGuide));
    el.btnCloseGuideFooter.addEventListener('click', () => closeModal(el.modalFixGuide));

    // Add Fix Modal
    el.btnOpenAddFix.addEventListener('click', openAddFixModal);
    el.btnCloseAddFix.addEventListener('click', () => closeModal(el.modalAddFix));
    el.btnCancelAddFix.addEventListener('click', () => closeModal(el.modalAddFix));
    el.formAddFix.addEventListener('submit', handleAddFixSubmit);

    // Add Task Modal
    el.btnOpenAddTask.addEventListener('click', openAddTaskModal);
    el.btnCloseAddTask.addEventListener('click', () => closeModal(el.modalAddTask));
    el.btnCancelAddTask.addEventListener('click', () => closeModal(el.modalAddTask));
    el.formAddTask.addEventListener('submit', handleAddTaskSubmit);

    // Add Note Form & Attachments
    if (el.formAddNote) {
      el.formAddNote.addEventListener('submit', handleAddNoteSubmit);
    }
    if (el.inputNoteImages) {
      el.inputNoteImages.addEventListener('change', handleNoteImagesSelected);
    }
    if (el.inputUpdateNoteImages) {
      el.inputUpdateNoteImages.addEventListener('change', handleUpdateNoteImagesSelected);
    }
    if (el.inputNoteText) {
      el.inputNoteText.addEventListener('paste', handleNoteTextareaPaste);
    }
    setupNoteDragDrop();

    // Category Filter Pills
    if (el.noteFilterBar) {
      el.noteFilterBar.addEventListener('click', (e) => {
        const btn = e.target.closest('.note-filter-pill');
        if (!btn) return;
        el.noteFilterBar.querySelectorAll('.note-filter-pill').forEach(p => p.classList.remove('active'));
        btn.classList.add('active');
        activeNoteCategoryFilter = btn.getAttribute('data-category') || 'all';
        if (state.selectedProduct) {
          renderNotesThread(state.selectedProduct.id, state.viewingRevision);
        }
      });
    }

    // Lightbox Modal
    if (el.btnCloseLightbox) {
      el.btnCloseLightbox.addEventListener('click', () => closeModal(el.modalImageLightbox));
    }
    if (el.modalImageLightbox) {
      el.modalImageLightbox.addEventListener('click', (e) => {
        if (e.target === el.modalImageLightbox) {
          closeModal(el.modalImageLightbox);
        }
      });
    }

    // QC Bench Form
    if (el.formQcBench) {
      el.formQcBench.addEventListener('submit', handleQcSubmit);
    }

    // Export Catalog
    el.btnExportCatalog.addEventListener('click', handleExportCatalog);
  }

  /* =========================================================================
     DATA LOADING & STATE SYNC
     ========================================================================= */

  function loadLocalData() {
    try {
      const saved = localStorage.getItem('alphax_design_data');
      if (saved) {
        const parsed = JSON.parse(saved);
        state.products = parsed.products || SEED_DATA.products;
        state.revisions = parsed.revisions || SEED_DATA.revisions;
        state.fixes = parsed.fixes || SEED_DATA.fixes;
        state.tasks = parsed.tasks || SEED_DATA.tasks;
        state.notes = parsed.notes || SEED_DATA.notes;
      } else {
        state.products = [...SEED_DATA.products];
        state.revisions = [...SEED_DATA.revisions];
        state.fixes = [...SEED_DATA.fixes];
        state.tasks = [...SEED_DATA.tasks];
        state.notes = [...SEED_DATA.notes];
        saveLocalData();
      }
    } catch (e) {
      state.products = [...SEED_DATA.products];
      state.revisions = [...SEED_DATA.revisions];
      state.fixes = [...SEED_DATA.fixes];
      state.tasks = [...SEED_DATA.tasks];
      state.notes = [...SEED_DATA.notes];
    }

    updateStats();
    populateCascadingDropdowns();
    renderMatrixTable();
  }

  function saveLocalData() {
    try {
      localStorage.setItem('alphax_design_data', JSON.stringify({
        products: state.products,
        revisions: state.revisions,
        fixes: state.fixes,
        tasks: state.tasks,
        notes: state.notes
      }));
    } catch (e) {
      console.warn("LocalStorage save error:", e);
    }
  }

  async function fetchRemoteData() {
    if (!APPS_SCRIPT_URL || APPS_SCRIPT_URL.includes('YOUR_DEPLOYED_APPS_SCRIPT')) return;
    try {
      Logger.api("📡 Syncing live database from Google Sheets...");
      const resp = await fetch(APPS_SCRIPT_URL);
      if (!resp.ok) {
        Logger.warn(`⚠️ Google Sheets returned HTTP ${resp.status}. (If 403, check Apps Script 'Who has access' = 'Anyone'). Falling back to LocalStorage cache.`);
        return;
      }
      const data = await resp.json();
      if (data.success) {
        if (data.products && data.products.length > 0) state.products = data.products;
        if (data.revisions && data.revisions.length > 0) state.revisions = data.revisions;
        if (data.fixes && data.fixes.length > 0) state.fixes = data.fixes;
        if (data.tasks && data.tasks.length > 0) state.tasks = data.tasks;
        if (data.notes && data.notes.length > 0) state.notes = data.notes;
        if (data.media && data.media.length > 0) state.media = data.media;
        saveLocalData();
        updateStats();
        populateCascadingDropdowns();
        if (state.viewMode === 'matrix') {
          renderMatrixTable();
        } else if (state.selectedProduct) {
          renderProductWorkspace(state.selectedProduct.id);
        }
        Logger.api(`✅ Live database synchronized from Google Sheets! (${state.products.length} Products, ${state.revisions.length} Revisions, ${state.fixes.length} Fixes).`);
      }
    } catch (err) {
      Logger.warn("⚡ Network/CORS Notice: Using offline cache for design tracker data.", err);
    }
  }

  /* =========================================================================
     AUTHENTICATION
     ========================================================================= */

  function checkAuthSession() {
    try {
      const savedUser = localStorage.getItem('alphax_staff_user');
      if (savedUser) {
        state.currentUser = JSON.parse(savedUser);
        updateUserBadge();
        closeModal(el.loginModal);
      } else {
        openModal(el.loginModal);
      }
    } catch (e) {
      openModal(el.loginModal);
    }
  }

  async function handleLoginSubmit(e) {
    e.preventDefault();
    const email = (el.loginEmail ? el.loginEmail.value : document.getElementById('login-email').value).trim().toLowerCase();
    const password = el.loginPassword ? el.loginPassword.value : document.getElementById('login-password').value;
    const hash = await sha256(password);

    Logger.auth(`Authenticating user: '${email}' | Computed SHA-256 Hash: ${hash.substring(0, 16)}...`);

    if (el.loginError) el.loginError.style.display = 'none';

    // 1. Try Apps Script API first (Live Google Sheets Auth)
    let matchedUser = null;
    const remoteResp = await apiCall('login', { email: email, password: password });
    if (remoteResp && remoteResp.success && remoteResp.user) {
      matchedUser = remoteResp.user;
      Logger.auth(`✅ Authenticated via Live Google Apps Script: ${matchedUser.name} (${matchedUser.role})`);
    } else if (remoteResp && remoteResp.message) {
      Logger.warn(`❌ Live Google Apps Script Auth response:`, remoteResp.message);
    }

    // 2. Check local offline seed staff fallback if offline
    if (!matchedUser) {
      matchedUser = SEED_STAFF.find(s => s.email.toLowerCase() === email && s.passwordHash === hash);
      if (matchedUser) {
        Logger.auth(`⚡ Authenticated via Local Offline Seed (Fallback): ${matchedUser.name}`);
      }
    }

    if (matchedUser) {
      state.currentUser = {
        name: matchedUser.name,
        email: matchedUser.email,
        role: matchedUser.role,
        avatar: matchedUser.avatar || matchedUser.name.split(' ').map(n => n[0]).join('')
      };
      localStorage.setItem('alphax_staff_user', JSON.stringify(state.currentUser));
      updateUserBadge();
      closeModal(el.loginModal);
      showToast(`Welcome back, ${state.currentUser.name}!`, 'success');
    } else {
      if (el.loginError) {
        el.loginError.textContent = "Invalid email or password. Please verify credentials against the Ticketing System.";
        el.loginError.style.display = 'block';
      }
      Logger.warn(`❌ Authentication failed for: ${email}`);
    }
  }

  function handleLogout() {
    state.currentUser = null;
    localStorage.removeItem('alphax_staff_user');
    el.currentUserName.textContent = "Not Authenticated";
    el.currentUserRole.textContent = "Staff Login Required";
    el.currentUserAvatar.textContent = "?";
    openModal(el.loginModal);
    showToast("Staff session logged out.", "warning");
  }

  async function handleChangePasswordSubmit(e) {
    e.preventDefault();
    const currentPass = document.getElementById('cp-current-password').value;
    const newPass = document.getElementById('cp-new-password').value;
    const confirmPass = document.getElementById('cp-confirm-password').value;
    const errorEl = document.getElementById('cp-error-msg');
    const successEl = document.getElementById('cp-success-msg');

    errorEl.style.display = 'none';
    successEl.style.display = 'none';

    if (newPass !== confirmPass) {
      errorEl.textContent = "New passwords do not match.";
      errorEl.style.display = 'block';
      return;
    }

    if (newPass.length < 6) {
      errorEl.textContent = "Password must be at least 6 characters.";
      errorEl.style.display = 'block';
      return;
    }

    const currentHash = await sha256(currentPass);
    if (state.currentUser) {
      const staffMember = SEED_STAFF.find(s => s.email.toLowerCase() === state.currentUser.email.toLowerCase());
      if (staffMember && staffMember.passwordHash !== currentHash) {
        errorEl.textContent = "Current password is incorrect.";
        errorEl.style.display = 'block';
        return;
      }

      const newHash = await sha256(newPass);
      if (staffMember) staffMember.passwordHash = newHash;

      // Sync with Google Sheets backend
      apiCall('changePassword', { email: state.currentUser.email, newPassword: newPass });

      successEl.style.display = 'block';
      setTimeout(() => {
        closeModal(el.changePasswordModal);
        showToast("Password updated successfully.", "success");
      }, 1200);
    }
  }

  function updateUserBadge() {
    if (!state.currentUser) return;
    el.currentUserName.textContent = state.currentUser.name;
    el.currentUserRole.textContent = state.currentUser.role;
    el.currentUserAvatar.textContent = state.currentUser.avatar || state.currentUser.name.split(' ').map(n => n[0]).join('');
  }

  /* =========================================================================
     STATS & COUNTS
     ========================================================================= */

  function updateStats() {
    const total = state.products.length;
    let finalized = 0, corrections = 0, engRev = 0, testing = 0;
    let plugin = 0, universal = 0, accessory = 0, protorico = 0;

    state.products.forEach(p => {
      const flags = p.statusFlags || [];
      if (flags.includes('finalized')) finalized++;
      if (flags.includes('need_corrections')) corrections++;
      if (flags.includes('need_engineering_rev')) engRev++;
      if (flags.includes('testing_validation')) testing++;

      if (p.category === 'plugin') plugin++;
      else if (p.category === 'universal') universal++;
      else if (p.category === 'accessory') accessory++;
      else if (p.category === 'protorico') protorico++;
    });

    if (el.statTotal) el.statTotal.textContent = total;
    if (el.statFinalized) el.statFinalized.textContent = finalized;
    if (el.statCorrections) el.statCorrections.textContent = corrections;
    if (el.statEngRev) el.statEngRev.textContent = engRev;
    if (el.statTesting) el.statTesting.textContent = testing;
    if (el.totalProductCount) el.totalProductCount.textContent = total;

    if (el.countAll) el.countAll.textContent = total;
    if (el.countPlugin) el.countPlugin.textContent = plugin;
    if (el.countUniversal) el.countUniversal.textContent = universal;
    if (el.countAccessory) el.countAccessory.textContent = accessory;
    if (el.countProtorico) el.countProtorico.textContent = protorico;
  }

  /* =========================================================================
     ALLDATA CASCADING PRODUCT SELECTOR ENGINE
     ========================================================================= */

  function populateCascadingDropdowns() {
    // Keep category choices clean
    // When Category is chosen -> populate Makes
    // When Make is chosen -> populate Models
    // When Model is chosen -> populate Revisions & show workspace
  }

  function handleCategoryChange() {
    const category = el.selectCategory.value;
    el.crumbCategory.textContent = category ? getCategoryLabel(category) : "All Categories";
    el.crumbMake.style.display = 'none';
    el.crumbSepMake.style.display = 'none';
    el.crumbModel.style.display = 'none';
    el.crumbSepModel.style.display = 'none';

    el.selectMake.innerHTML = '<option value="">-- Select Make / Line --</option>';
    el.selectModel.innerHTML = '<option value="">-- Select Model --</option>';
    el.selectRevision.innerHTML = '<option value="current">Current Active Rev</option>';

    if (!category) {
      el.stepMakeWrap.classList.add('disabled');
      el.selectMake.disabled = true;
      el.stepModelWrap.classList.add('disabled');
      el.selectModel.disabled = true;
      el.stepRevisionWrap.classList.add('disabled');
      el.selectRevision.disabled = true;
      showMatrixView();
      return;
    }

    // Filter makes in this category
    const makes = [...new Set(state.products.filter(p => p.category === category).map(p => p.make))].sort();

    makes.forEach(m => {
      const opt = document.createElement('option');
      opt.value = m;
      opt.textContent = m;
      el.selectMake.appendChild(opt);
    });

    el.stepMakeWrap.classList.remove('disabled');
    el.selectMake.disabled = false;
    el.stepModelWrap.classList.add('disabled');
    el.selectModel.disabled = true;
    el.stepRevisionWrap.classList.add('disabled');
    el.selectRevision.disabled = true;

    // Filter matrix table by this category
    state.activeCategory = category;
    el.filterTabs.forEach(t => {
      if (t.getAttribute('data-filter') === category) t.classList.add('active');
      else t.classList.remove('active');
    });
    renderMatrixTable();
  }

  function handleMakeChange() {
    const category = el.selectCategory.value;
    const make = el.selectMake.value;
    Logger.log(`🚗 Make selected: '${make || 'None'}'`);

    if (!make) {
      el.crumbMake.style.display = 'none';
      el.crumbSepMake.style.display = 'none';
      el.stepModelWrap.classList.add('disabled');
      el.selectModel.disabled = true;
      el.stepRevisionWrap.classList.add('disabled');
      el.selectRevision.disabled = true;
      renderMatrixTable();
      return;
    }

    el.crumbMake.textContent = make;
    el.crumbMake.style.display = 'inline';
    el.crumbSepMake.style.display = 'inline';
    el.crumbModel.style.display = 'none';
    el.crumbSepModel.style.display = 'none';

    el.selectModel.innerHTML = '<option value="">-- Select Model / Spec --</option>';

    const filtered = state.products.filter(p => p.category === category && p.make === make);
    filtered.forEach(p => {
      const opt = document.createElement('option');
      opt.value = p.id;
      const statusTag = p.lifecycleStatus === 'obsolete' ? ' [OBSOLETE]' : (p.lifecycleStatus === 'deprecated' ? ' [DEPRECATED]' : '');
      opt.textContent = `${p.name} (${p.currentRevision})${statusTag}`;
      el.selectModel.appendChild(opt);
    });

    el.stepModelWrap.classList.remove('disabled');
    el.selectModel.disabled = false;
    el.stepRevisionWrap.classList.add('disabled');
    el.selectRevision.disabled = true;

    renderMatrixTable();
  }

  function handleModelChange() {
    const productId = el.selectModel.value;
    if (!productId) {
      el.crumbModel.style.display = 'none';
      el.crumbSepModel.style.display = 'none';
      el.stepRevisionWrap.classList.add('disabled');
      el.selectRevision.disabled = true;
      showMatrixView();
      return;
    }

    const product = state.products.find(p => p.id === productId);
    if (!product) return;

    el.crumbModel.textContent = product.name;
    el.crumbModel.style.display = 'inline';
    el.crumbSepModel.style.display = 'inline';

    // Populate Revisions
    el.selectRevision.innerHTML = '<option value="current">Current Active Rev (' + product.currentRevision + ')</option>';
    const prodRevs = state.revisions.filter(r => r.productId === productId);
    prodRevs.forEach(r => {
      const opt = document.createElement('option');
      opt.value = r.id;
      opt.textContent = `${r.revisionNumber} - ${r.isCurrent ? '[Active]' : '[Archived]'}`;
      el.selectRevision.appendChild(opt);
    });

    el.stepRevisionWrap.classList.remove('disabled');
    el.selectRevision.disabled = false;

    // Switch view to Product Workspace
    Logger.log(`🔬 Opening Product Workspace: ${productId}`);
    renderProductWorkspace(productId);
  }

  function handleRevisionChange() {
    const revId = el.selectRevision.value;
    if (!state.selectedProduct) return;

    if (revId === 'current') {
      renderProductWorkspace(state.selectedProduct.id);
    } else {
      const selectedRev = state.revisions.find(r => r.id === revId);
      if (selectedRev) {
        el.wpRevisionNumber.textContent = selectedRev.revisionNumber;
        el.wpRevisionStatus.textContent = selectedRev.isCurrent ? "Current Active" : "Historical Archive";
        showToast(`Viewing historical records for ${selectedRev.revisionNumber}`, "info");
      }
    }
  }

  function resetCascadingFilters() {
    el.selectCategory.value = '';
    el.selectMake.innerHTML = '<option value="">-- Select Make / Line --</option>';
    el.selectModel.innerHTML = '<option value="">-- Select Model --</option>';
    el.selectRevision.innerHTML = '<option value="current">Current Active Rev</option>';

    el.stepMakeWrap.classList.add('disabled');
    el.selectMake.disabled = true;
    el.stepModelWrap.classList.add('disabled');
    el.selectModel.disabled = true;
    el.stepRevisionWrap.classList.add('disabled');
    el.selectRevision.disabled = true;

    el.crumbCategory.textContent = "All Categories";
    el.crumbMake.style.display = 'none';
    el.crumbSepMake.style.display = 'none';
    el.crumbModel.style.display = 'none';
    el.crumbSepModel.style.display = 'none';

    state.activeCategory = 'all';
    el.filterTabs.forEach(t => {
      if (t.getAttribute('data-filter') === 'all') t.classList.add('active');
      else t.classList.remove('active');
    });

    showMatrixView();
  }

  function handleQuickSearch(e) {
    const query = e.target.value.trim().toLowerCase();
    state.searchQuery = query;
    el.btnClearSearch.style.display = query ? 'block' : 'none';
    renderMatrixTable();
  }

  function clearSearch() {
    el.selectorQuickSearch.value = '';
    state.searchQuery = '';
    el.btnClearSearch.style.display = 'none';
    renderMatrixTable();
  }

  /* =========================================================================
     VIEW SWITCHING & MATRIX RENDERING
     ========================================================================= */

  function showMatrixView() {
    state.viewMode = 'matrix';
    state.selectedProduct = null;
    el.viewWorkspace.style.display = 'none';
    el.viewMatrix.style.display = 'block';
    renderMatrixTable();
  }

  function renderMatrixTable() {
    el.matrixTableBody.innerHTML = '';

    let list = state.products;

    // Filter by Category
    if (state.activeCategory && state.activeCategory !== 'all') {
      list = list.filter(p => p.category === state.activeCategory);
    }

    // Filter by Make (if chosen in dropdown)
    const selectedMake = el.selectMake.value;
    if (selectedMake) {
      list = list.filter(p => p.make === selectedMake);
    }

    // Filter by Status Toggles
    if (state.filterCorrectionsOnly) {
      list = list.filter(p => (p.statusFlags || []).includes('need_corrections'));
    }
    if (state.filterEngRevOnly) {
      list = list.filter(p => (p.statusFlags || []).includes('need_engineering_rev'));
    }

    // Filter by Obsolete / Deprecated
    if (!state.showObsolete && !state.searchQuery) {
      list = list.filter(p => (p.lifecycleStatus || 'active') !== 'obsolete');
    }

    // Filter by Quick Search
    if (state.searchQuery) {
      const q = state.searchQuery;
      list = list.filter(p =>
        p.name.toLowerCase().includes(q) ||
        p.make.toLowerCase().includes(q) ||
        p.model.toLowerCase().includes(q) ||
        p.id.toLowerCase().includes(q) ||
        (p.description || '').toLowerCase().includes(q) ||
        (p.channels || '').toLowerCase().includes(q)
      );
    }

    if (list.length === 0) {
      const tr = document.createElement('tr');
      tr.innerHTML = `<td colspan="9" style="text-align: center; padding: 2.5rem; color: var(--ax-text-dim);">No ECU products match the selected filters or search query.</td>`;
      el.matrixTableBody.appendChild(tr);
      return;
    }

    list.forEach(p => {
      const tr = document.createElement('tr');

      // Status badges html
      const flagsHtml = (p.statusFlags || []).map(f => {
        switch (f) {
          case 'finalized': return `<span class="alphax-badge badge-finalized">Finalized</span>`;
          case 'need_corrections': return `<span class="alphax-badge badge-corrections">⚠️ Need Rework</span>`;
          case 'need_engineering_rev': return `<span class="alphax-badge badge-eng-rev">⚙️ Eng Rev</span>`;
          case 'testing_validation': return `<span class="alphax-badge badge-testing">In Testing</span>`;
          default: return '';
        }
      }).join(' ');

      // Pre-shipment fixes count for this product
      const fixCount = state.fixes.filter(f => f.productId === p.id).length;
      const fixBadge = fixCount > 0
        ? `<span class="alphax-badge badge-corrections" style="cursor: pointer;" onclick="window.AlphaXTracker.openProductRework('${p.id}')">${fixCount} Fix Guide${fixCount > 1 ? 's' : ''}</span>`
        : `<span style="color: var(--ax-text-dim); font-size: 0.78rem;">Clean PCB</span>`;

      const lifecycle = p.lifecycleStatus || 'active';
      let lifecycleBadge = `<span class="alphax-badge badge-lifecycle-active"><span class="badge-dot dot-active"></span> ACTIVE</span>`;
      if (lifecycle === 'deprecated') {
        lifecycleBadge = `<span class="alphax-badge badge-lifecycle-deprecated"><span class="badge-dot dot-deprecated"></span> DEPRECATED</span>`;
      } else if (lifecycle === 'obsolete') {
        lifecycleBadge = `<span class="alphax-badge badge-lifecycle-obsolete"><span class="badge-dot dot-obsolete"></span> OBSOLETE</span>`;
      }

      tr.innerHTML = `
        <td>${lifecycleBadge}</td>
        <td><span class="title-category-pill" style="margin: 0; font-size: 0.65rem;">${getCategoryLabel(p.category)}</span></td>
        <td><strong style="color: #fff;">${p.make}</strong></td>
        <td>
          <div style="font-weight: 700; color: #fff; cursor: pointer;" onclick="window.AlphaXTracker.selectProductById('${p.id}')">${p.name}</div>
          <div style="font-size: 0.78rem; color: var(--ax-text-dim); margin-top: 0.15rem;">${p.model}</div>
        </td>
        <td><span class="alphax-rev-pill">${p.currentRevision}</span></td>
        <td><div style="display: flex; gap: 0.3rem; flex-wrap: wrap;">${flagsHtml || '<span style="color:var(--ax-text-dim)">-</span>'}</div></td>
        <td>
          <div style="font-weight: 700; color: #34d399;">${p.msrp}</div>
          <div style="font-size: 0.75rem; color: var(--ax-text-dim);">Dlr: ${p.dealerPrice}</div>
        </td>
        <td>${fixBadge}</td>
        <td>
          <span style="font-weight: 700; color: #fff;">${p.stockQty || '0'}</span>
          <span style="font-size: 0.75rem; color: var(--ax-text-dim);"> (${p.casesQty || '0'} cs)</span>
        </td>
        <td>
          <button class="alphax-btn alphax-btn-sm alphax-btn-secondary" onclick="window.AlphaXTracker.selectProductById('${p.id}')">
            Open Workspace &rsaquo;
          </button>
        </td>
      `;
      el.matrixTableBody.appendChild(tr);
    });
  }

  /* =========================================================================
     PRODUCT WORKSPACE
     ========================================================================= */

  
  function handleViewingRevisionChange() {
    if (!state.selectedProduct) return;
    state.viewingRevision = el.wpViewingRevisionSelect.value;
    Logger.log(`📜 Viewing Revision switched to: '${state.viewingRevision}' -> Filtering notes and reworks.`);
    renderNotesThread(state.selectedProduct.id, state.viewingRevision);
    renderFixesList(state.selectedProduct.id, state.viewingRevision);
  }

  function renderProductWorkspace(productId) {
    const product = state.products.find(p => p.id === productId);
    if (!product) return;

    state.selectedProduct = product;
    state.viewMode = 'workspace';

    el.viewMatrix.style.display = 'none';
    el.viewWorkspace.style.display = 'block';

    // Populate Workspace Header
    el.wpCategory.textContent = getCategoryLabel(product.category);
    el.wpName.textContent = product.name;
    el.wpModelSpec.textContent = `${product.make} • ${product.model}`;
    el.wpRevisionNumber.textContent = product.currentRevision;
    el.wpRevisionStatus.textContent = "Current Active";

    // Populate Currently Viewing Revision dropdown
    if (el.wpViewingRevisionSelect) {
      el.wpViewingRevisionSelect.innerHTML = '';
      
      const curRev = product.currentRevision || 'Rev 1.0';
      state.viewingRevision = curRev;

      const optCur = document.createElement('option');
      optCur.value = curRev;
      optCur.textContent = curRev + ' (Current Active)';
      optCur.selected = true;
      el.wpViewingRevisionSelect.appendChild(optCur);

      const optAll = document.createElement('option');
      optAll.value = 'all';
      optAll.textContent = 'All Revisions (Entire History)';
      el.wpViewingRevisionSelect.appendChild(optAll);

      const pastRevs = state.revisions
        .filter(r => r.productId === product.id && r.revisionNumber !== curRev)
        .map(r => r.revisionNumber);

      const uniquePast = [...new Set(pastRevs)];
      uniquePast.forEach(rev => {
        const opt = document.createElement('option');
        opt.value = rev;
        opt.textContent = rev;
        el.wpViewingRevisionSelect.appendChild(opt);
      });
    }
    if (el.wpProductLifecycle) {
      const lc = product.lifecycleStatus || 'active';
      el.wpProductLifecycle.className = `alphax-badge badge-lifecycle-${lc}`;
      el.wpProductLifecycle.innerHTML = `<span class="badge-dot dot-${lc}"></span> ${lc.toUpperCase()}`;
    }

    // Pricing & Inventory
    el.wpMsrp.textContent = product.msrp || '$0';
    el.wpDealerPrice.textContent = product.dealerPrice || '$0';
    el.wpStock.textContent = product.stockQty || '0';
    el.wpCases.textContent = product.casesQty || '0';

    // Specs
    el.wpSpecMcu.textContent = product.processorArch || 'STM32 168MHz';
    el.wpSpecChannels.textContent = product.channels || 'Standard I/O';
    el.wpSpecCore.textContent = product.coreRequired || 'No';
    el.wpSpecJobber.textContent = product.jobberPrice || '$0';
    el.wpSpecDesc.textContent = product.description || 'No additional product notes.';

    // Resource links
    el.wpLinkPinout.href = product.pinoutUrl || '#';
    el.wpLinkPinout.style.display = product.pinoutUrl ? 'flex' : 'none';
    el.wpLinkTune.href = product.baseTuneUrl || '#';
    el.wpLinkTune.style.display = product.baseTuneUrl ? 'flex' : 'none';

    // Status Flags Checkboxes
    const flags = product.statusFlags || [];
    el.flagFinalized.checked = flags.includes('finalized');
    el.flagCorrections.checked = flags.includes('need_corrections');
    el.flagEngRev.checked = flags.includes('need_engineering_rev');
    el.flagTesting.checked = flags.includes('testing_validation');

    // Render Sub-components
    renderFixesList(product.id, state.viewingRevision);
    renderRevisionTimeline(product.id);
    renderTasksList(product.id);
    renderNotesThread(product.id, state.viewingRevision);

    // Sync Cascading Pickers
    el.selectCategory.value = product.category;
    handleCategoryChange();
    el.selectMake.value = product.make;
    handleMakeChange();
    el.selectModel.value = product.id;

    el.crumbModel.textContent = product.name;
    el.crumbModel.style.display = 'inline';
    el.crumbSepModel.style.display = 'inline';
  }

  function handleStatusFlagsChange() {
    if (!state.selectedProduct) return;

    const newFlags = [];
    if (el.flagFinalized.checked) newFlags.push('finalized');
    if (el.flagCorrections.checked) newFlags.push('need_corrections');
    if (el.flagEngRev.checked) newFlags.push('need_engineering_rev');
    if (el.flagTesting.checked) newFlags.push('testing_validation');

    state.selectedProduct.statusFlags = newFlags;
    Logger.log(`🚩 Status Flags updated for ${state.selectedProduct.id}:`, newFlags);
    saveLocalData();
    updateStats();

    // Async sync with Google Apps Script
    apiCall('saveProduct', { product: state.selectedProduct, author: state.currentUser ? state.currentUser.name : 'Staff' });

    showToast("Design status flags updated.", "success");
  }

  /* =========================================================================
     PRE-SHIPMENT REWORK CHECKLIST & VISUAL FIX GUIDES
     ========================================================================= */

  function renderFixesList(productId, viewingRev) {
    el.wpFixesList.innerHTML = '';
    const revFilter = viewingRev || (state.viewingRevision || 'all');
    let fixes = state.fixes.filter(f => f.productId === productId);
    if (revFilter && revFilter !== 'all') {
      fixes = fixes.filter(f => f.applicableRevision === 'All' || f.applicableRevision === revFilter);
    }
    el.wpFixesCount.textContent = fixes.length;

    if (fixes.length === 0) {
      el.wpFixesList.innerHTML = `
        <div style="text-align: center; padding: 1.5rem; color: var(--ax-text-dim); background: #0a0f1c; border-radius: var(--ax-radius-md); border: 1px dashed var(--ax-border);">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-bottom: 0.35rem; color: #34d399;"><polyline points="20 6 9 17 4 12"/></svg>
          <div>No pre-shipment rework required for this revision. Board is clean.</div>
        </div>
      `;
      return;
    }

    fixes.forEach(f => {
      const card = document.createElement('div');
      card.className = 'fix-item-card';

      const hasImages = f.images && f.images.length > 0;
      const imagesBadge = hasImages ? `<span class="alphax-badge badge-testing" style="font-size: 0.7rem;">📷 ${f.images.length} Diagram(s)</span>` : '';

      card.innerHTML = `
        <div class="fix-item-header">
          <div class="fix-item-title">
            <span class="alphax-badge badge-corrections" style="font-size: 0.72rem;">${getCategoryLabel(f.category)}</span>
            <span>${f.title}</span>
          </div>
          <div>${imagesBadge}</div>
        </div>
        <p class="fix-item-instructions">${f.instructions}</p>
        <div class="fix-item-actions">
          <span style="font-size: 0.75rem; color: var(--ax-text-dim);">Applicable: ${f.applicableRevision || 'All'}</span>
          <button class="btn-view-guide" onclick="window.AlphaXTracker.openFixGuideModal('${f.id}')">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            View Visual Guide
          </button>
        </div>
      `;
      el.wpFixesList.appendChild(card);
    });
  }

  function openFixGuideModal(fixId) {
    const fix = state.fixes.find(f => f.id === fixId);
    if (!fix) return;

    const product = state.products.find(p => p.id === fix.productId) || { name: 'AlphaX ECU' };

    el.guideModalTitle.textContent = fix.title;
    el.guideMetaProduct.textContent = product.name;
    el.guideMetaRevision.textContent = fix.applicableRevision || 'All Revisions';
    el.guideMetaCategory.textContent = getCategoryLabel(fix.category);
    el.guideInstructionsText.textContent = fix.instructions;

    el.guideImageGallery.innerHTML = '';

    if (fix.images && fix.images.length > 0) {
      fix.images.forEach(imgFile => {
        const thumb = document.createElement('div');
        thumb.className = 'guide-image-thumb';
        const imgUrl = resolveFixImageUrl(imgFile);
        thumb.innerHTML = `
          <img src="${imgUrl}" onerror="this.src='data:image/svg+xml,%3Csvg xmlns=\\'http://www.w3.org/2000/svg\\' width=\\'200\\' height=\\'160\\' viewBox=\\'0 0 200 160\\'%3E%3Crect width=\\'200\\' height=\\'160\\' fill=\\'%23050811\\'/ %3E%3Ctext x=\\'50%25\\' y=\\'50%25\\' fill=\\'%2338bdf8\\' dominant-baseline=\\'middle\\' text-anchor=\\'middle\\' font-family=\\'sans-serif\\' font-size=\\'11\\'%3E${imgFile}%3C/text%3E%3C/svg%3E'" alt="${imgFile}" />
          <div class="guide-image-caption">${imgFile}</div>
        `;
        thumb.addEventListener('click', () => {
          window.open(imgUrl, '_blank');
        });
        el.guideImageGallery.appendChild(thumb);
      });
      document.getElementById('guide-media-section').style.display = 'block';
    } else {
      document.getElementById('guide-media-section').style.display = 'none';
    }

    openModal(el.modalFixGuide);
  }

  
  function calculateNextRev(revStr) {
    if (!revStr) return 'Rev 2.0';
    const match = revStr.match(/Rev\s*([0-9]+)\.([0-9]+)/i);
    if (match) {
      const major = parseInt(match[1], 10);
      const minor = parseInt(match[2], 10);
      return ;
    }
    const matchSingle = revStr.match(/Rev\s*([0-9]+)$/i);
    if (matchSingle) {
      const num = parseInt(matchSingle[1], 10);
      return ;
    }
    const matchLetter = revStr.match(/Rev\s*([A-Za-z])/i);
    if (matchLetter) {
      const charCode = matchLetter[1].toUpperCase().charCodeAt(0);
      return ;
    }
    return ;
  }

  function openAddFixModal() {
    if (!state.selectedProduct) return;
    const p = state.selectedProduct;
    el.addfixProductId.value = p.id;
    el.addfixTitle.value = '';
    el.addfixInstructions.value = '';

    // Populate dynamic revision dropdown
    el.addfixApplicableRev.innerHTML = '';

    const optAll = document.createElement('option');
    optAll.value = 'All';
    optAll.textContent = 'All Revisions (Global Rework)';
    el.addfixApplicableRev.appendChild(optAll);

    const curRev = p.currentRevision || 'Rev 1.0';
    const optCur = document.createElement('option');
    optCur.value = curRev;
    optCur.textContent = curRev + ' (Current Active Revision)';
    optCur.selected = true;
    el.addfixApplicableRev.appendChild(optCur);

    // List all past/known revisions for this product
    const productRevs = state.revisions
      .filter(r => r.productId === p.id && r.revisionNumber !== curRev)
      .map(r => r.revisionNumber);

    const uniqueRevs = [...new Set(productRevs)];
    uniqueRevs.forEach(rev => {
      const opt = document.createElement('option');
      opt.value = rev;
      opt.textContent = rev;
      el.addfixApplicableRev.appendChild(opt);
    });

    openModal(el.modalAddFix);
  }

  async function handleAddFixSubmit(e) {
    e.preventDefault();
    const newFix = {
      id: 'FIX-' + Date.now(),
      productId: el.addfixProductId.value,
      applicableRevision: el.addfixApplicableRev.value || 'All',
      title: el.addfixTitle.value.trim(),
      instructions: el.addfixInstructions.value.trim(),
      category: el.addfixCategory.value,
      isMandatory: el.addfixIsMandatory.checked,
      guideDoc: '',
      images: [],
      createdAt: new Date().toISOString()
    };

    state.fixes.push(newFix);

    // Auto flag product as needing corrections if mandatory fix added
    if (state.selectedProduct && !state.selectedProduct.statusFlags.includes('need_corrections')) {
      state.selectedProduct.statusFlags.push('need_corrections');
    }

    saveLocalData();
    updateStats();
    renderFixesList(newFix.productId);
    closeModal(el.modalAddFix);

    apiCall('savePreShipmentFix', { fix: newFix });
    showToast("Pre-shipment rework step added.", "success");
  }

  /* =========================================================================
     REVISION BUMP WIZARD & TIMELINE
     ========================================================================= */

  function renderRevisionTimeline(productId) {
    el.wpRevisionTimeline.innerHTML = '';
    const revs = state.revisions.filter(r => r.productId === productId).sort((a, b) => new Date(b.releaseDate) - new Date(a.releaseDate));

    if (revs.length === 0) {
      el.wpRevisionTimeline.innerHTML = `<div style="color: var(--ax-text-dim); font-size: 0.85rem;">Initial revision record.</div>`;
      return;
    }

    revs.forEach(r => {
      const node = document.createElement('div');
      node.className = `timeline-node ${r.isCurrent ? 'current' : ''}`;
      const dateStr = new Date(r.releaseDate).toLocaleDateString();

      node.innerHTML = `
        <div class="timeline-dot"></div>
        <div class="timeline-content">
          <div class="timeline-header">
            <span class="timeline-rev-title">${r.revisionNumber} ${r.isCurrent ? '<span class="alphax-badge badge-finalized" style="font-size:0.65rem;">Active</span>' : ''}</span>
            <span class="timeline-date">${dateStr}</span>
          </div>
          <p class="timeline-changelog">${r.changelog}</p>
          <div class="timeline-author">Released by: <strong>${r.bumpedBy || 'Staff'}</strong></div>
          ${r.reworkInstructions ? `<div style="font-size: 0.78rem; color: #fbbf24; margin-top: 0.35rem;">⚠️ Rework: ${r.reworkInstructions}</div>` : ''}
        </div>
      `;
      el.wpRevisionTimeline.appendChild(node);
    });
  }

  function openBumpRevisionModal() {
    if (!state.selectedProduct) return;
    el.bumpProductId.value = state.selectedProduct.id;
    el.bumpProductNameDisplay.value = state.selectedProduct.name;
    el.bumpCurrentRevDisplay.value = state.selectedProduct.currentRevision;
    el.bumpNewRevision.value = '';
    el.bumpChangelog.value = '';
    el.bumpRemainingRework.value = '';

    // Populate active fixes checklist to mark as resolved in silicon
    el.bumpFixesChecklist.innerHTML = '';
    const activeFixes = state.fixes.filter(f => f.productId === state.selectedProduct.id);
    if (activeFixes.length > 0) {
      activeFixes.forEach(f => {
        const item = document.createElement('label');
        item.className = 'flag-checkbox';
        item.style.marginBottom = '0.35rem';
        item.innerHTML = `
          <input type="checkbox" name="resolved_fixes" value="${f.id}" />
          <span>${f.title} (${f.applicableRevision})</span>
        `;
        el.bumpFixesChecklist.appendChild(item);
      });
    } else {
      el.bumpFixesChecklist.innerHTML = `<div style="color: var(--ax-text-dim); font-size: 0.8rem;">No active manual bench fixes on file.</div>`;
    }

    openModal(el.modalBumpRevision);
  }

  async function handleBumpRevisionSubmit(e) {
    e.preventDefault();
    const productId = el.bumpProductId.value;
    const newRev = el.bumpNewRevision.value.trim();
    const changelog = el.bumpChangelog.value.trim();
    const remainingRework = el.bumpRemainingRework.value.trim();
    const author = state.currentUser ? state.currentUser.name : 'Staff';

    // Get resolved fix IDs
    const checkedFixes = Array.from(document.querySelectorAll('input[name="resolved_fixes"]:checked')).map(c => c.value);

    // 1. Mark existing product revisions as not current
    state.revisions.forEach(r => {
      if (r.productId === productId) r.isCurrent = false;
    });

    // 2. Add new Revision
    const newRevObj = {
      id: 'REV-' + productId + '-' + newRev.replace(/[^a-zA-Z0-9]/g, ''),
      productId: productId,
      revisionNumber: newRev,
      releaseDate: new Date().toISOString(),
      bumpedBy: author,
      changelog: changelog,
      statusAtRevision: "finalized",
      reworkInstructions: remainingRework,
      isCurrent: true
    };
    state.revisions.push(newRevObj);

    // 3. Update Product record
    if (state.selectedProduct) {
      state.selectedProduct.currentRevision = newRev;
      // If all fixes resolved and no remaining rework, remove need_corrections flag
      if (remainingRework === '') {
        state.selectedProduct.statusFlags = state.selectedProduct.statusFlags.filter(f => f !== 'need_corrections');
      }
    }

    // 4. Archive resolved fixes
    state.fixes = state.fixes.filter(f => !checkedFixes.includes(f.id));

    // 5. Add audit design note
    state.notes.push({
      id: 'NOTE-' + Date.now(),
      productId: productId,
      revisionNumber: newRev,
      author: author,
      text: `🚀 BUMPED REVISION to ${newRev}. Changelog: ${changelog}. Remaining bench rework: ${remainingRework || 'None'}.`,
      category: 'revision_bump',
      timestamp: new Date().toISOString()
    });

    saveLocalData();
    updateStats();
    Logger.log(`🔬 Opening Product Workspace: ${productId}`);
    renderProductWorkspace(productId);
    closeModal(el.modalBumpRevision);

    apiCall('bumpRevision', {
      productId: productId,
      newRevisionNumber: newRev,
      changelog: changelog,
      remainingRework: remainingRework,
      resolvedFixes: checkedFixes,
      author: author
    });

    showToast(`Hardware revision bumped to ${newRev}!`, "success");
  }

  /* =========================================================================
     ENGINEERING TASKS & BUG TRACKER
     ========================================================================= */

  function renderTasksList(productId) {
    el.wpTasksList.innerHTML = '';
    const tasks = state.tasks.filter(t => t.productId === productId);
    el.wpTasksCount.textContent = tasks.length;

    if (tasks.length === 0) {
      el.wpTasksList.innerHTML = `<div style="color: var(--ax-text-dim); font-size: 0.85rem; padding: 0.5rem 0;">No open engineering tasks for this product.</div>`;
      return;
    }

    tasks.forEach(t => {
      const card = document.createElement('div');
      card.className = 'task-card';

      card.innerHTML = `
        <div class="task-header">
          <span class="task-title">${t.title}</span>
          <span class="task-priority-badge priority-${t.priority}">${t.priority}</span>
        </div>
        ${t.description ? `<p class="task-desc">${t.description}</p>` : ''}
        <div class="task-footer">
          <span>Assigned: <strong>${t.assignedTo || 'Unassigned'}</strong> (Target: ${t.targetRevision || 'Next Rev'})</span>
          <select class="task-status-select" onchange="window.AlphaXTracker.updateTaskStatus('${t.id}', this.value)">
            <option value="backlog" ${t.status === 'backlog' ? 'selected' : ''}>Backlog</option>
            <option value="in_progress" ${t.status === 'in_progress' ? 'selected' : ''}>In Progress</option>
            <option value="bench_testing" ${t.status === 'bench_testing' ? 'selected' : ''}>Bench Testing</option>
            <option value="resolved_in_next_rev" ${t.status === 'resolved_in_next_rev' ? 'selected' : ''}>Resolved in Next Rev</option>
            <option value="closed" ${t.status === 'closed' ? 'selected' : ''}>Closed</option>
          </select>
        </div>
      `;
      el.wpTasksList.appendChild(card);
    });
  }

  function openAddTaskModal() {
    if (!state.selectedProduct) return;
    const p = state.selectedProduct;
    el.addtaskId.value = p.id;
    el.addtaskTitle.value = '';
    el.addtaskDesc.value = '';

    // Populate dynamic target revision dropdown
    el.addtaskTargetRev.innerHTML = '';

    const curRev = p.currentRevision || 'Rev 1.0';
    const nextRev = calculateNextRev(curRev);

    const optNext = document.createElement('option');
    optNext.value = nextRev;
    optNext.textContent = nextRev + ' (Next Upcoming Revision)';
    optNext.selected = true;
    el.addtaskTargetRev.appendChild(optNext);

    const optCur = document.createElement('option');
    optCur.value = curRev;
    optCur.textContent = curRev + ' (Current Active Revision)';
    el.addtaskTargetRev.appendChild(optCur);

    // List other known revisions for this product
    const productRevs = state.revisions
      .filter(r => r.productId === p.id && r.revisionNumber !== curRev)
      .map(r => r.revisionNumber);

    const uniqueRevs = [...new Set(productRevs)];
    uniqueRevs.forEach(rev => {
      const opt = document.createElement('option');
      opt.value = rev;
      opt.textContent = rev;
      el.addtaskTargetRev.appendChild(opt);
    });

    const optFuture = document.createElement('option');
    optFuture.value = 'Future Rev';
    optFuture.textContent = 'Future Rev / General Backlog';
    el.addtaskTargetRev.appendChild(optFuture);

    openModal(el.modalAddTask);
  }

  async function handleAddTaskSubmit(e) {
    e.preventDefault();
    const newTask = {
      id: 'TASK-' + Date.now(),
      productId: el.addtaskId.value,
      title: el.addtaskTitle.value.trim(),
      description: el.addtaskDesc.value.trim(),
      priority: el.addtaskPriority.value,
      status: el.addtaskStatus.value,
      targetRevision: el.addtaskTargetRev.value || 'Next Rev',
      assignedTo: el.addtaskAssigned.value,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };

    state.tasks.push(newTask);
    saveLocalData();
    renderTasksList(newTask.productId);
    closeModal(el.modalAddTask);

    apiCall('saveEngineeringTask', { task: newTask });
    showToast("Engineering design task logged.", "success");
  }

  function updateTaskStatus(taskId, newStatus) {
    const task = state.tasks.find(t => t.id === taskId);
    if (!task) return;

    task.status = newStatus;
    task.updatedAt = new Date().toISOString();
    saveLocalData();

    apiCall('saveEngineeringTask', { task: task });
    showToast(`Task status updated to ${newStatus}.`, "info");
  }

  /* =========================================================================
     DESIGN NOTES & DISCUSSIONS (WITH PHOTO ATTACHMENTS & LIGHTBOX)
     ========================================================================= */

  // Helper to safely escape HTML
  function escapeHtml(str) {
    if (!str) return '';
    return str.toString()
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  // Helper to resolve fix and note image URLs
  function resolveFixImageUrl(imgFile) {
    if (!imgFile) return '';
    if (imgFile.startsWith('data:') || imgFile.startsWith('http://') || imgFile.startsWith('https://') || imgFile.startsWith('blob:') || imgFile.startsWith('/')) {
      return imgFile;
    }
    return 'assets/fixes-media/' + imgFile;
  }

  // Helper: Client-side canvas image compressor
  function compressImageFile(file, maxWidth = 1200, quality = 0.82) {
    return new Promise((resolve) => {
      if (!file || !file.type || !file.type.startsWith('image/')) {
        resolve(null);
        return;
      }
      if (file.type === 'image/svg+xml' || file.type === 'image/gif' || file.size < 100 * 1024) {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = () => resolve(null);
        reader.readAsDataURL(file);
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          let w = img.width;
          let h = img.height;
          if (w > maxWidth || h > maxWidth) {
            if (w > h) {
              h = Math.round((h * maxWidth) / w);
              w = maxWidth;
            } else {
              w = Math.round((w * maxWidth) / h);
              h = maxWidth;
            }
          }
          const canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, w, h);
          const dataUrl = canvas.toDataURL('image/jpeg', quality);
          resolve(dataUrl);
        };
        img.onerror = () => resolve(e.target.result);
        img.src = e.target.result;
      };
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(file);
    });
  }

  // Note Category Details & Badges
  function getNoteCategoryDetails(cat) {
    switch (cat) {
      case 'bench_testing':
        return { label: '🔬 Bench Testing', badgeClass: 'badge-cat-bench_testing' };
      case 'hardware_design':
        return { label: '⚡ Hardware Design', badgeClass: 'badge-cat-hardware_design' };
      case 'calibration':
        return { label: '📊 Calibration / Tune', badgeClass: 'badge-cat-calibration' };
      case 'assembly_qc':
        return { label: '🛠️ Assembly / QC', badgeClass: 'badge-cat-assembly_qc' };
      case 'general':
      default:
        return { label: '📝 General Note', badgeClass: 'badge-cat-general' };
    }
  }

  // Lightbox Modal Opener
  function openImageLightbox(src, title, caption) {
    if (!el.modalImageLightbox) return;
    if (el.lightboxImg) el.lightboxImg.src = resolveFixImageUrl(src);
    if (el.lightboxTitle) el.lightboxTitle.textContent = title || "Image Preview";
    if (el.lightboxCaption) el.lightboxCaption.textContent = caption || "";
    openModal(el.modalImageLightbox);
  }

  // Render pending image preview chips in note form
  function renderPendingNoteImages() {
    if (!el.notePendingImages) return;
    el.notePendingImages.innerHTML = '';
    if (pendingNoteImages.length === 0) {
      el.notePendingImages.style.display = 'none';
      if (el.noteImageCounter) el.noteImageCounter.style.display = 'none';
      return;
    }
    el.notePendingImages.style.display = 'flex';
    if (el.noteImageCounter) {
      el.noteImageCounter.textContent = pendingNoteImages.length;
      el.noteImageCounter.style.display = 'inline-block';
    }

    pendingNoteImages.forEach((imgSrc, idx) => {
      const chip = document.createElement('div');
      chip.className = 'pending-img-chip';
      chip.innerHTML = `
        <img src="${imgSrc}" alt="Attached preview ${idx + 1}" />
        <button type="button" class="pending-img-remove" title="Remove photo">&times;</button>
      `;
      chip.querySelector('.pending-img-remove').addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        pendingNoteImages.splice(idx, 1);
        renderPendingNoteImages();
      });
      el.notePendingImages.appendChild(chip);
    });
  }

  // File Picker Change Handler for New Note
  async function handleNoteImagesSelected(e) {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    for (const f of files) {
      const dataUrl = await compressImageFile(f);
      if (dataUrl) pendingNoteImages.push(dataUrl);
    }
    e.target.value = '';
    renderPendingNoteImages();
    showToast(`📸 ${files.length} photo(s) attached to note.`, 'info');
  }

  // Clipboard Paste Handler (Ctrl+V / Cmd+V)
  async function handleNoteTextareaPaste(e) {
    const items = (e.clipboardData || (e.originalEvent && e.originalEvent.clipboardData) || {}).items;
    if (!items) return;
    let pastedCount = 0;
    for (let i = 0; i < items.length; i++) {
      if (items[i].type && items[i].type.indexOf('image') !== -1) {
        const file = items[i].getAsFile();
        if (file) {
          const dataUrl = await compressImageFile(file);
          if (dataUrl) {
            pendingNoteImages.push(dataUrl);
            pastedCount++;
          }
        }
      }
    }
    if (pastedCount > 0) {
      renderPendingNoteImages();
      showToast(`📸 ${pastedCount} screenshot attached from clipboard!`, 'info');
    }
  }

  // Drag & Drop Handler on Note Form
  function setupNoteDragDrop() {
    const form = el.formAddNote;
    if (!form) return;
    ['dragenter', 'dragover'].forEach(eventName => {
      form.addEventListener(eventName, (e) => {
        e.preventDefault();
        e.stopPropagation();
        form.classList.add('drag-over');
      }, false);
    });
    ['dragleave', 'drop'].forEach(eventName => {
      form.addEventListener(eventName, (e) => {
        e.preventDefault();
        e.stopPropagation();
        form.classList.remove('drag-over');
      }, false);
    });
    form.addEventListener('drop', async (e) => {
      const dt = e.dataTransfer;
      const files = Array.from(dt.files || []).filter(f => f.type.startsWith('image/'));
      if (!files.length) return;
      for (const f of files) {
        const dataUrl = await compressImageFile(f);
        if (dataUrl) pendingNoteImages.push(dataUrl);
      }
      renderPendingNoteImages();
      showToast(`📸 ${files.length} photo(s) attached via drag & drop!`, 'info');
    }, false);
  }

  // Adding Photos to an Existing Note
  function triggerAddPhotoToExistingNote(noteId) {
    targetNoteForImageUpdate = state.notes.find(n => n.id === noteId);
    if (!targetNoteForImageUpdate) return;
    if (el.inputUpdateNoteImages) {
      el.inputUpdateNoteImages.value = '';
      el.inputUpdateNoteImages.click();
    }
  }

  async function handleUpdateNoteImagesSelected(e) {
    if (!targetNoteForImageUpdate) return;
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    if (!targetNoteForImageUpdate.images || !Array.isArray(targetNoteForImageUpdate.images)) {
      targetNoteForImageUpdate.images = [];
    }

    for (const f of files) {
      const dataUrl = await compressImageFile(f);
      if (dataUrl) {
        targetNoteForImageUpdate.images.push(dataUrl);
      }
    }

    e.target.value = '';
    saveLocalData();
    if (state.selectedProduct) {
      renderNotesThread(state.selectedProduct.id, state.viewingRevision);
    }
    apiCall('addDesignNote', targetNoteForImageUpdate);
    showToast(`📸 ${files.length} photo(s) added to note!`, 'success');
    targetNoteForImageUpdate = null;
  }

  // Delete a Note
  function deleteDesignNote(noteId) {
    const idx = state.notes.findIndex(n => n.id === noteId);
    if (idx === -1) return;
    if (!confirm("Are you sure you want to delete this discussion note?")) return;
    state.notes.splice(idx, 1);
    saveLocalData();
    if (state.selectedProduct) {
      renderNotesThread(state.selectedProduct.id, state.viewingRevision);
    }
    apiCall('deleteDesignNote', { noteId: noteId });
    showToast("Note removed.", "info");
  }

  // Main Render Function for Discussion Thread
  function renderNotesThread(productId, viewingRev) {
    if (!el.wpNotesThread) return;
    el.wpNotesThread.innerHTML = '';
    const revFilter = viewingRev || (state.viewingRevision || 'all');
    let notes = state.notes.filter(n => n.productId === productId);
    if (revFilter && revFilter !== 'all') {
      notes = notes.filter(n => n.revisionNumber === revFilter);
    }
    if (activeNoteCategoryFilter && activeNoteCategoryFilter !== 'all') {
      notes = notes.filter(n => (n.category || 'general') === activeNoteCategoryFilter);
    }
    notes.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

    if (revFilter && revFilter !== 'all') {
      const filterBanner = document.createElement('div');
      filterBanner.className = 'note-filter-banner';
      filterBanner.innerHTML = `
        <div class="note-filter-banner-text">
          <span>Showing notes for <strong>${escapeHtml(revFilter)}</strong> (${notes.length} note${notes.length === 1 ? '' : 's'})</span>
        </div>
        <button type="button" class="btn-show-all-revs" onclick="window.AlphaXTracker.resetNotesFilter()" title="Show notes from all revisions">
          Show All Revisions ✕
        </button>
      `;
      el.wpNotesThread.appendChild(filterBanner);
    }

    if (notes.length === 0) {
      const emptyMsg = document.createElement('div');
      emptyMsg.style.cssText = 'color: var(--ax-text-dim); font-size: 0.85rem; padding: 1.25rem 0; text-align: center;';
      emptyMsg.textContent = activeNoteCategoryFilter !== 'all' ? `No ${getNoteCategoryDetails(activeNoteCategoryFilter).label} entries found.` : 'No design notes or discussions recorded yet.';
      el.wpNotesThread.appendChild(emptyMsg);
      return;
    }

    notes.forEach(n => {
      const card = document.createElement('div');
      card.className = 'note-card';
      const timeStr = new Date(n.timestamp).toLocaleString();
      const catInfo = getNoteCategoryDetails(n.category);

      let imagesHtml = '';
      if (n.images && Array.isArray(n.images) && n.images.length > 0) {
        imagesHtml = `
          <div class="note-images-gallery">
            ${n.images.map((img, idx) => `
              <div class="note-img-thumb" data-note-id="${n.id}" data-img-idx="${idx}" title="Click to enlarge photo">
                <img src="${resolveFixImageUrl(img)}" onerror="this.src='data:image/svg+xml,%3Csvg xmlns=\\'http://www.w3.org/2000/svg\\' width=\\'100\\' height=\\'80\\' viewBox=\\'0 0 100 80\\'%3E%3Crect width=\\'100\\' height=\\'80\\' fill=\\'%23050811\\'/ %3E%3Ctext x=\\'50%25\\' y=\\'50%25\\' fill=\\'%2338bdf8\\' dominant-baseline=\\'middle\\' text-anchor=\\'middle\\' font-family=\\'sans-serif\\' font-size=\\'9\\'%3EImage%3C/text%3E%3C/svg%3E'" alt="Note Attachment ${idx + 1}" />
                <span class="note-img-zoom-icon">🔍</span>
              </div>
            `).join('')}
          </div>
        `;
      }

      card.innerHTML = `
        <div class="note-card-header">
          <div class="note-author-block">
            <span class="note-author">${escapeHtml(n.author || 'Staff')}</span>
            <span class="note-rev-tag">(${escapeHtml(n.revisionNumber || 'Rev')})</span>
            <span class="note-cat-badge ${catInfo.badgeClass}">${catInfo.label}</span>
          </div>
          <span class="note-timestamp">${timeStr}</span>
        </div>
        <p class="note-body">${escapeHtml(n.text || '')}</p>
        ${imagesHtml}
        <div class="note-card-footer">
          <button type="button" class="alphax-btn alphax-btn-secondary alphax-btn-xs btn-add-note-photo" data-note-id="${n.id}" title="Add another photo to this note">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
            + Add Picture
          </button>
          <button type="button" class="alphax-btn alphax-btn-danger alphax-btn-xs btn-delete-note" data-note-id="${n.id}" title="Delete note">
            Delete
          </button>
        </div>
      `;

      // Bind thumbnail clicks for lightbox
      const thumbs = card.querySelectorAll('.note-img-thumb');
      thumbs.forEach(th => {
        th.addEventListener('click', () => {
          const idx = parseInt(th.getAttribute('data-img-idx'), 10);
          const imgSrc = n.images[idx];
          openImageLightbox(imgSrc, `${n.author || 'Staff'} • ${catInfo.label}`, `${n.text || ''} (${timeStr})`);
        });
      });

      // Bind Add Photo button
      const addPhotoBtn = card.querySelector('.btn-add-note-photo');
      if (addPhotoBtn) {
        addPhotoBtn.addEventListener('click', () => {
          triggerAddPhotoToExistingNote(n.id);
        });
      }

      // Bind Delete button
      const deleteBtn = card.querySelector('.btn-delete-note');
      if (deleteBtn) {
        deleteBtn.addEventListener('click', () => {
          deleteDesignNote(n.id);
        });
      }

      el.wpNotesThread.appendChild(card);
    });
  }

  // Handle Note Submission
  async function handleAddNoteSubmit(e) {
    e.preventDefault();
    if (!state.selectedProduct) return;

    const text = el.inputNoteText.value.trim();
    if (!text && pendingNoteImages.length === 0) {
      showToast("Please enter note text or attach a photo.", "warning");
      return;
    }

    const author = state.currentUser ? state.currentUser.name : 'Staff';
    const category = el.selectNoteCategory ? el.selectNoteCategory.value : 'general';

    Logger.log(`💬 New Design Note logged for ${state.selectedProduct.id} (${(state.viewingRevision && state.viewingRevision !== 'all') ? state.viewingRevision : state.selectedProduct.currentRevision}) by ${author}: "${(text || 'Image Attachment').substring(0, 50)}..."`);
    const newNote = {
      id: 'NOTE-' + Date.now(),
      productId: state.selectedProduct.id,
      revisionNumber: (state.viewingRevision && state.viewingRevision !== 'all') ? state.viewingRevision : state.selectedProduct.currentRevision,
      author: author,
      text: text || '(Photo Attachment)',
      category: category,
      images: [...pendingNoteImages],
      timestamp: new Date().toISOString()
    };

    state.notes.push(newNote);
    saveLocalData();
    renderNotesThread(state.selectedProduct.id, state.viewingRevision);
    
    // Clear inputs and reset attachments
    el.inputNoteText.value = '';
    pendingNoteImages = [];
    renderPendingNoteImages();

    apiCall('addDesignNote', newNote);
    showToast("Design note posted with pictures.", "success");
  }

  /* =========================================================================
     PRE-SHIPMENT QC BENCH MODULE
     ========================================================================= */

  async function handleQcSubmit(e) {
    e.preventDefault();
    if (!state.selectedProduct) return;

    const serialNumber = el.qcSerialNumber.value.trim();
    const baseTune = el.qcBaseTune.value.trim();
    const inspector = state.currentUser ? state.currentUser.name : 'Staff';

    const qcSummary = `[PRE-SHIPMENT QC PASSED] Serial: ${serialNumber}\n` +
                      `- Hardware Rev: ${state.selectedProduct.currentRevision}\n` +
                      `- 12V & 5V Rail Power: OK\n` +
                      `- Trigger RPM Sync: OK\n` +
                      `- Injector / Ignition Fire: OK\n` +
                      `- Mandatory Reworks Inspected: OK\n` +
                      `- Base Tune Flashed: ${baseTune}\n` +
                      `- QC Inspector: ${inspector}`;

    Logger.log(`💬 New Design Note logged for ${state.selectedProduct.id} (${(state.viewingRevision && state.viewingRevision !== 'all') ? state.viewingRevision : state.selectedProduct.currentRevision}) by ${author}: "${text.substring(0, 50)}..."`);
    const newNote = {
      id: 'QC-' + Date.now(),
      productId: state.selectedProduct.id,
      revisionNumber: (state.viewingRevision && state.viewingRevision !== 'all') ? state.viewingRevision : state.selectedProduct.currentRevision,
      author: inspector,
      text: qcSummary,
      category: 'assembly_qc',
      timestamp: new Date().toISOString()
    };

    state.notes.push(newNote);
    saveLocalData();
    renderNotesThread(state.selectedProduct.id);

    apiCall('saveQCSignoff', {
      productId: state.selectedProduct.id,
      revisionNumber: (state.viewingRevision && state.viewingRevision !== 'all') ? state.viewingRevision : state.selectedProduct.currentRevision,
      serialNumber: serialNumber,
      baseTuneName: baseTune,
      inspector: inspector
    });

    el.qcSerialNumber.value = '';
    el.qcBaseTune.value = '';
    el.formQcBench.reset();

    showToast(`✅ Pre-shipment QC stamped for unit ${serialNumber}!`, "success");
  }

  /* =========================================================================
     PRODUCT CATALOG CRUD
     ========================================================================= */

  function openProductCrudModal(product) {
    if (product) {
      el.modalProductTitle.textContent = "Edit ECU Product";
      el.crudProductId.value = product.id;
      el.crudCategory.value = product.category;
      el.crudMake.value = product.make;
      el.crudName.value = product.name;
      el.crudModel.value = product.model;
      el.crudRevision.value = product.currentRevision;
      if (el.crudLifecycle) el.crudLifecycle.value = product.lifecycleStatus || 'active';
      el.crudMcu.value = product.processorArch || '';
      el.crudChannels.value = product.channels || '';
      el.crudMsrp.value = product.msrp || '';
      el.crudDealer.value = product.dealerPrice || '';
      el.crudCore.value = product.coreRequired || 'No';
      el.crudDesc.value = product.description || '';
      el.crudPinoutUrl.value = product.pinoutUrl || '';
      el.crudTuneUrl.value = product.baseTuneUrl || '';
      el.btnDeleteProduct.style.display = 'block';
    } else {
      el.modalProductTitle.textContent = "Add New ECU Product";
      el.crudProductId.value = '';
      el.crudCategory.value = 'plugin';
      el.crudMake.value = '';
      el.crudName.value = '';
      el.crudModel.value = '';
      el.crudRevision.value = 'Rev 1.0';
      if (el.crudLifecycle) el.crudLifecycle.value = 'active';
      el.crudMcu.value = 'STM32 168MHz';
      el.crudChannels.value = '4 Inj / 4 Ign';
      el.crudMsrp.value = '$800';
      el.crudDealer.value = '$560';
      el.crudCore.value = 'No';
      el.crudDesc.value = '';
      el.crudPinoutUrl.value = '';
      el.crudTuneUrl.value = '';
      el.btnDeleteProduct.style.display = 'none';
    }
    openModal(el.modalProductCrud);
  }

  async function handleProductCrudSubmit(e) {
    e.preventDefault();
    const existingId = el.crudProductId.value;
    const productId = existingId || ('PROD-' + Date.now());

    const productObj = {
      id: productId,
      name: el.crudName.value.trim(),
      category: el.crudCategory.value,
      make: el.crudMake.value.trim(),
      model: el.crudModel.value.trim(),
      currentRevision: el.crudRevision.value.trim() || 'Rev 1.0',
      lifecycleStatus: el.crudLifecycle ? el.crudLifecycle.value : 'active',
      statusFlags: existingId ? (state.selectedProduct ? state.selectedProduct.statusFlags : ['finalized']) : ['finalized'],
      msrp: el.crudMsrp.value.trim(),
      jobberPrice: '$' + Math.round(parseFloat((el.crudMsrp.value.replace(/[^0-9.]/g, '') || 0) * 0.8)),
      dealerPrice: el.crudDealer.value.trim(),
      coreRequired: el.crudCore.value.trim(),
      processorArch: el.crudMcu.value.trim(),
      channels: el.crudChannels.value.trim(),
      description: el.crudDesc.value.trim(),
      pinoutUrl: el.crudPinoutUrl.value.trim(),
      baseTuneUrl: el.crudTuneUrl.value.trim(),
      stockQty: existingId && state.selectedProduct ? state.selectedProduct.stockQty : "0",
      casesQty: existingId && state.selectedProduct ? state.selectedProduct.casesQty : "0"
    };

    if (existingId) {
      const idx = state.products.findIndex(p => p.id === existingId);
      if (idx !== -1) state.products[idx] = productObj;
    } else {
      state.products.push(productObj);
      // Add initial revision record
      state.revisions.push({
        id: 'REV-' + productId + '-1.0',
        productId: productId,
        revisionNumber: productObj.currentRevision,
        releaseDate: new Date().toISOString(),
        bumpedBy: state.currentUser ? state.currentUser.name : 'Staff',
        changelog: 'Initial product record creation.',
        statusAtRevision: 'finalized',
        reworkInstructions: '',
        isCurrent: true
      });
    }

    saveLocalData();
    updateStats();
    populateCascadingDropdowns();
    closeModal(el.modalProductCrud);

    apiCall('saveProduct', { product: productObj, author: state.currentUser ? state.currentUser.name : 'Staff' });

    Logger.log(`🔬 Opening Product Workspace: ${productId}`);
    renderProductWorkspace(productId);
    showToast(existingId ? "Product specs updated." : "New ECU product added to catalog!", "success");
  }

  async function handleDeleteProductSubmit() {
    const productId = el.crudProductId.value;
    if (!productId) return;

    if (!confirm("Are you sure you want to remove this product from the active tracker? Historical logs will be archived.")) {
      return;
    }

    state.products = state.products.filter(p => p.id !== productId);
    saveLocalData();
    updateStats();
    populateCascadingDropdowns();
    closeModal(el.modalProductCrud);

    apiCall('deleteProduct', { productId: productId });

    showMatrixView();
    showToast("Product deleted from tracker.", "warning");
  }

  function handleExportCatalog() {
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify({
      exportedAt: new Date().toISOString(),
      products: state.products,
      revisions: state.revisions,
      fixes: state.fixes,
      tasks: state.tasks
    }, null, 2));

    const downloadAnchor = document.createElement('a');
    downloadAnchor.setAttribute("href", dataStr);
    downloadAnchor.setAttribute("download", `alphax_design_catalog_${new Date().toISOString().slice(0, 10)}.json`);
    document.body.appendChild(downloadAnchor);
    downloadAnchor.click();
    downloadAnchor.remove();

    showToast("Catalog exported as JSON.", "success");
  }

  /* =========================================================================
     UTILITY HELPERS
     ========================================================================= */

  function getCategoryLabel(cat) {
    switch (cat) {
      case 'plugin': return 'Plug & Play ECU';
      case 'universal': return 'Universal ECU';
      case 'accessory': return 'Accessory / Module';
      case 'protorico': return 'ProtoRico Dev Board';
      case 'jumper': return 'Solder Jumper';
      case 'pullup_pulldown': return 'Pullup / Pulldown';
      case 'component_swap': return 'Component Swap';
      case 'trace_cut': return 'Trace Cut';
      case 'firmware': return 'Firmware Jumper';
      default: return cat;
    }
  }

  function openModal(modalEl) {
    if (!modalEl) return;
    modalEl.classList.add('active');
    modalEl.scrollTop = 0;
    try {
      window.scrollTo({ top: 0, behavior: 'instant' });
    } catch (e) {}
  }

  function closeModal(modalEl) {
    if (!modalEl) return;
    modalEl.classList.remove('active');
  }

  function showToast(message, type = 'info') {
    if (!el.toastContainer) return;
    const toast = document.createElement('div');
    toast.className = `alphax-toast toast-${type}`;
    toast.textContent = message;
    el.toastContainer.appendChild(toast);
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(100%)';
      toast.style.transition = 'all 0.3s ease';
      setTimeout(() => toast.remove(), 300);
    }, 3500);
  }

  // Expose global controller functions for inline events
  window.AlphaXTracker = {
    selectProductById: renderProductWorkspace,
    resetNotesFilter: () => {
      if (el.wpViewingRevisionSelect) {
        el.wpViewingRevisionSelect.value = 'all';
        handleViewingRevisionChange();
      }
    },
    openProductRework: (productId) => {
      Logger.log(`🔬 Opening Product Workspace: ${productId}`);
      renderProductWorkspace(productId);
      const fixesCard = document.getElementById('card-fixes');
      if (fixesCard) fixesCard.scrollIntoView({ behavior: 'smooth' });
    },
    openFixGuideModal: openFixGuideModal,
    updateTaskStatus: updateTaskStatus,
    openImageLightbox: openImageLightbox,
    addPhotoToNote: triggerAddPhotoToExistingNote,
    deleteNote: deleteDesignNote
  };

})();
